/* function nativefun(funname, param, callback) {
	if(!param) {
		param = {};
	}
	if(!callback) {
		callback = function() {};
	}
	if(s != 'wx') {
		window.WebViewJavascriptBridge.callHandler(funname, param, callback);
	}
}

//区分苹果手机和安卓手机
var browser = {
	versions: function() {
		var u = navigator.userAgent,
			app = navigator.appVersion;
		return { //移动终端浏览器版本信息
			ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
			iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
			iPad: u.indexOf('iPad') > -1, //是否iPad,
			iPadOS: u.indexOf('iPadOS') > -1, //是否iPad
		};
	}(),
}


function registerfun(funname, dealfun) {
	if(s == 'app') {
		WebViewJavascriptBridge.registerHandler(funname, dealfun);
	}
}


function setupWebViewJavascriptBridge(callback) {

	if(browser.versions.iPhone || browser.versions.iPad || browser.versions.ios || browser.versions.iPadOS ) {
		if(window.WebViewJavascriptBridge) {
			return callback(WebViewJavascriptBridge);
		}
		if(window.WVJBCallbacks) {

			return window.WVJBCallbacks.push(callback);
		}
		window.WVJBCallbacks = [callback];
		var WVJBIframe = document.createElement('iframe');
		WVJBIframe.style.display = 'none';
		WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
		document.documentElement.appendChild(WVJBIframe);
		setTimeout(function() {
			document.documentElement.removeChild(WVJBIframe)
		}, 0)

		//alert('苹果');

	}
	if(browser.versions.android) {

		document.addEventListener('WebViewJavascriptBridgeReady', function() {
			callback(WebViewJavascriptBridge)
		}, false)

		//alert('安卓');
	}

} */

/* function linkcss(path){
	var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.href = path;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    head.appendChild(link);
} */

//<link rel="stylesheet" href="//bosdev.liangyihui.net/weui/1.1.2/style/weui.min.css">
//<link rel="stylesheet" href=//bosdev.liangyihui.net/jquery-weui/1.2.0/css/jquery-weui.min.css"">
//<link rel="stylesheet" href="//bosdev.liangyihui.net/minit_style.css">
//<link rel="stylesheet" href="//bosdev.liangyihui.net/minireset.css/0.0.2/minireset.css">
//linkcss('//doctor.liangyihui.net/wx/css/style.css')
/* setTimeout(function(){

	linkcss("//bosdev.liangyihui.net/weui/1.1.2/style/weui.min.css");
	linkcss("//bosdev.liangyihui.net/jquery-weui/1.2.0/css/jquery-weui.min.css");
	//linkcss("//bosdev.liangyihui.net/minit_style.css");
	linkcss("//bosdev.liangyihui.net/mint-ui/2.2.13/style.css");
	linkcss("//bosdev.liangyihui.net/minireset.css/0.0.2/minireset.css");
	linkcss("//doctor.liangyihui.net/com/style.css?v=6");
	linkcss("//doctor.liangyihui.net/com/vote.css");
	linkcss(Global_root_path + "doctor/hbs/css/audio.css");
	linkcss('//doctor.liangyihui.net/wx/css/style.css')
},250); */


/*
$.smartScroll = function(container, selectorScrollable) {
    // 如果没有滚动容器选择器，或者已经绑定了滚动时间，忽略
    if (!selectorScrollable || container.data('isBindScroll')) {
        return;
    }

    // 是否是搓浏览器
    // 自己在这里添加判断和筛选
    var isSBBrowser;

    var data = {
        posY: 0,
        maxscroll: 0
    };

    // 事件处理
    container.on({
        touchstart: function (event) {
            var events = event.touches[0] || event;

            // 先求得是不是滚动元素或者滚动元素的子元素
            var elTarget = $(event.target);

            if (!elTarget.length) {
                return;
            }

            var elScroll;

            // 获取标记的滚动元素，自身或子元素皆可
            if (elTarget.is(selectorScrollable)) {
                elScroll = elTarget;
            } else if ((elScroll = elTarget.parents(selectorScrollable)).length == 0) {
                elScroll = null;
            }

            if (!elScroll) {
                return;
            }

            // 当前滚动元素标记
            data.elScroll = elScroll;

            // 垂直位置标记
            data.posY = events.pageY;
            data.scrollY = elScroll.scrollTop();
            // 是否可以滚动
            data.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;
        },
        touchmove: function () {
            // 如果不足于滚动，则禁止触发整个窗体元素的滚动
            if (data.maxscroll <= 0 || isSBBrowser) {
                // 禁止滚动
                event.preventDefault();
            }
            // 滚动元素
            var elScroll = data.elScroll;
            // 当前的滚动高度
            var scrollTop = elScroll.scrollTop();

            // 现在移动的垂直位置，用来判断是往上移动还是往下
            var events = event.touches[0] || event;
            // 移动距离
            var distanceY = events.pageY - data.posY;

            if (isSBBrowser) {
                elScroll.scrollTop(data.scrollY - distanceY);
                elScroll.trigger('scroll');
                return;
            }

            // 上下边缘检测
            if (distanceY > 0 && scrollTop == 0) {
                // 往上滑，并且到头
                // 禁止滚动的默认行为
                event.preventDefault();
                return;
            }

            // 下边缘检测
            if (distanceY < 0 && (scrollTop + 1 >= data.maxscroll)) {
                // 往下滑，并且到头
                // 禁止滚动的默认行为
                event.preventDefault();
                return;
            }
        },
        touchend: function () {
            data.maxscroll = 0;
        }
    });

    // 防止多次重复绑定
    container.data('isBindScroll', true);
};
*/

//$(window).bind('beforeunload',function(){
//	return confirm('您输入的内容尚未保存，确定离开此页面吗？');
//});
//解除绑定，一般放在提交触发事件中
//$(window).unbind('beforeunload');

//	window.onbeforeunload = function(event) {
//	return confirm("确定退出吗");
//}


(function(window, document){
  function createHttpRequest()
  {
    if(window.ActiveXObject){
      return new ActiveXObject("Microsoft.XMLHTTP");
    }
    else if(window.XMLHttpRequest){
      return new XMLHttpRequest();
    }
  }
  function AliLogTracker(host,project,logstore)
  {
    this.uri_ = '//' + project + '.' + host + '/logstores/' + logstore + '/track?APIVersion=0.6.0';
    this.params_=new Array();
    this.httpRequest_ = createHttpRequest();
  }
  AliLogTracker.prototype = {
    push: function(key,value) {
      if(!key || !value) {
        return;
      }
      this.params_.push(key);
      this.params_.push(value);
    },
    logger: function()
    {
      var url = this.uri_;
      var k = 0;
      while(this.params_.length > 0)
      {
        if(k % 2 == 0)
        {
          url += '&' + encodeURIComponent(this.params_.shift());
        }
        else
        {
          url += '=' + encodeURIComponent(this.params_.shift());
        }
        ++k;
      }
      try
      {
        this.httpRequest_.open("GET",url,true);
        this.httpRequest_.send(null);
      }
      catch (ex)
      {
        if (window && window.console && typeof window.console.log === 'function')
        {
          console.log("Failed to log to ali log service because of this exception:\n" + ex);
          console.log("Failed log data:", url);
        }
      }

    }
  };
  window.Tracker = AliLogTracker;
})(window, document);


function aliyunlog(data,doctimeopt,store){

  var host = 'cn-hangzhou.log.aliyuncs.com';
  var project = 'lyhdoctor';
  var logstore = 'lyhdoctor';
  if (doctimeopt && !store) {
    logstore = 'apptime';
  } else if (store) {
    logstore = store;
  }
  //this.logger =  new window.Tracker('lyhdoctor.cn-hangzhou.log.aliyuncs.com','lyhdoctor','lyhloga');

  var logger = new window.Tracker(host,project,logstore);
  for(var key in data){
    logger.push(key, data[key]);
  }
  //logger.push('customer', 'zhangsan');
  //logger.push('product', 'iphone 6s');
  //logger.push('price', 5500);

  logger.logger();

}

/**
  * 分享文案处理，由于微信分享文案长度不超过1kb，此处超过1024个字符截取前1023个字符拼接...展示
  * 此处sharedesc为空时会返回空值，分享时分享文案也为空，各个页面调用wsharep.sharedesc时自行处理空值时的情况
  * @param {string} sharedesc
  * returns {string} sharedesc 分享文案
  */
function changeShareDesc(sharedesc){
  if(sharedesc && sharedesc.length && sharedesc.length > 1024){
    sharedesc = sharedesc.substring(0,1023) + '...';
  }
  return sharedesc
}

var s = '';
var auth1 = '';
var auth2 = '';
var version = '';
var head = {
  auth: null,
  auth2: null,
  cid: "",
  cver: "",
  sid: null,
  runPlatform: '',
  extensions: [
    {
      "name": "platform",
      "value": "iOS"
    },
    {
      "name": "phoneType",
      "value": "iPhone Simulator"
    },
    {
      "name": "phoneVersion",
      "value": "13.3"
    },
    {
      "name": "networkType",
      "value": "WIFI"
    },
    {
      "name": "userType",
      "value": "0"
    }
  ],
  patientToken: ""
};
var doctorMiniProgramId = "gh_c24bee55bedd" //医生端微信小程序id(原医学工具小程序)
var doctorMiniProgramPaths = { //医生端微信小程序页面path
  article: 'pages/ArticlePage/index?loadUrl=', //文章
  live: 'pages/LiveClassPage/index?loadUrl=', //公开课
  commonWeb: 'pages/CommonWebPage/index?loadUrl=', //通用的web页面
  drugsHome: 'pages/MedicationGuide/MedicationGuide', //肿瘤用药首页
  questTab: 'pages/QuestTab/index',            //答题tab
  doctorToolsIndex: 'pages/DoctorToolsIndex/DoctorToolsIndex', // 医学公式聚合页
  BMICompute: 'pages/bodyCompute/BMI', // BMI 计算公式
  answerCenterProxy: 'pages/AnswerCenterProxy/index', // 答题中心代理页，用于分享、完成任务等操作
  assistantQrCode: 'pages/AssistantQrCode/index' // 小助手二维码（?type=medical(医务工作者) 和 enterprise(企业)）
}

var wsharep = {
  sharetitle: "",
  shareurl: "",
  sharepic: "",
  sharedesc: "与全世界的肿瘤医生一起工作、学习、交流",
  shareMini: 0, // 是否分享到小程序
  miniProgramId: '', //小程序原始id
  miniProgramPath: '', //小程序对应的path
  miniProgramImageUrl: null, //小程序对应的卡片比例5:4裁剪
  miniProgramImageBase64: null, // 工具对应截图分享图像

  bp: null,
  shareCode: null,
  successfun: function () {
    console.log('default wshare succ')
  }
};

liveuser = {};
chatunreader = -1;

$(window).bind("pageshow", function (event) {
  if (event.originalEvent.persisted) {

  }
});

function eruda() {
  javascript: (function () {
    var script = document.createElement('script');
    script.src = "//cdn.jsdelivr.net/npm/eruda";
    document.body.appendChild(script);
    script.onload = function () {
      eruda.init()
    }
  })();

}

function recordTnmResult(disease) {
  let saveObjc = localStorage.getItem('tools_tnm_complete_data')
  let nowTime = Math.floor(Date.now() / 1000)
  let nowDate = timeStamp2String(nowTime, 'sd')
  let newSave = {}
  if (saveObjc) {
    let saveData = JSON.parse(saveObjc) || {}
    let sDate = saveData.date
    if (nowDate === sDate) {
      // 当天次数+1
      let num = parseInt(saveData.num) + 1
      let show = saveData.show
      newSave = {
        'num': num + '',
        'show': show,
        'date': nowDate,
        'name': ''
      }
      if (num == 3) {
        newSave.name = disease
      }
      if (saveData.name && saveData.name.length > 0) {
        newSave.name = saveData.name
      }
    } else {
      // 不是当天
      newSave = {
        'num': '1',
        'show': false,
        'date': nowDate,
        'name': ''
      }
    }
  } else {
    // 本地未存过数据
    newSave = {
      'num': '1',
      'show': false,
      'date': nowDate,
      'name': ''
    }
  }
  if (newSave && newSave.num) {
    localStorage.setItem('tools_tnm_complete_data', JSON.stringify(newSave))
  }
}

function getRecordTnmData() {
  let saveObjc = localStorage.getItem('tools_tnm_complete_data')
  let saveData = {}
  if (saveObjc) {
    saveData = JSON.parse(saveObjc) || {}
  }
  return saveData
}

function saveRecordTnmData() {
  let saveObjc = localStorage.getItem('tools_tnm_complete_data')
  if (saveObjc) {
    let saveData = JSON.parse(saveObjc) || {}
    saveData.show = true
    localStorage.setItem('tools_tnm_complete_data', JSON.stringify(saveData))
  }
}

function openapp() {
  // document.location.href = 'https://bacvcj.jgshare.cn/AAmR';
  goapp('home', '')
}

function getJskUrl() {
  return Global_jsk_url;

  /* 线上：
  https://jsk.liangyihui.net/?type=prddoctor
  {
      "url":"https://doctor.liangyihui.net/"
  }
  线下：
  https://jsk.liangyihui.net/?type=demodoctor
  {
      "url":"https://demom.liangyihui.net/"
  }
  // return Global_root_path + "doctor/tp/Index/jsk";
  */
}
function appLinkUrl(type, url) {
  // 版本判断
  let belVersion = false // 9.5后自己链接
  // if (compareVer(head.cver, '9.5') === -1) {// 9.5前极光魔链
  //   belVersion = true
  // }

  // 暂时就这一种情况（原生页链接——AAm9）
  if (type && type == 'lyhurl') {
    if (belVersion) {
      return 'https://bacvcj.jgshare.cn/AAm9?actionurl=' + encodeURIComponent(Base64.encode(url))
    } else {
      return '#/LyhMLink/lyhurl?actionurl=' + encodeURIComponent(Base64.encode(url))
    }
  }
  return url
}

function goapp(type, idUrl) {
  let param = type
  let idOrUrl = idUrl
  // 版本判断 belVersion:true 是极光魔链; false 是良医汇LyhMLink
  let belVersion = false // 9.5后自己链接
  // if (compareVer(head.cver, '9.5') === -1) {// 9.5前极光魔链
  //   belVersion = true
  // }

  if (param) {
    //——————————————特殊类型，兼容之前
    if (param == 'subjectList') {
      idOrUrl = 'lyh://native.liangyihui.net/allSubjects'
      param = 'lyhurl'
    }
    if (param == 'columnList56') {
      idOrUrl = 'lyh://native.liangyihui.net/allColumns'
      param = 'lyhurl'
    }
    if (param == 'socialextdetail') {
      param = 'DongTaiDetail'
    }
    if (param == 'MyMedalSharePage' || param == 'ShareMedalPage') {
      //我的勋章 或者 分享的勋章详情页面，打开APP的勋章墙
      idOrUrl = Global_root_path + '/#/MyMedal/0'
      param = 'web'
    }
    if (param == 'DoctorToolsIndex' || param == 'TumorLevel1' || param == 'TumorSelect' || param == 'TumorBluePrintList' || param == 'SelectedTumorPage' || param == 'MyCollectList' || param == 'chemoProject' || param == '2019under35') {
      idOrUrl = location.href
      param = 'web'
    }
    if (param == 'answerProjectHome') {
      idOrUrl = 'lyh://native.liangyihui.net/NewWeb?needNotShowShareBtn=1&url=' + Global_root_path + '/#/AnswerQCenter'
      param = 'lyhurl'
    }

    //——————————————基础类型
    if (param == 'doc') {
      // 文章——AAWj
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAWj?docId=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/NewsDetail?docId=' + idOrUrl
      }
      return
    }
    if (param == 'live') {
      // 公开课——AAmI
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmI?docId=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/Live?docId=' + idOrUrl
      }
      return
    }
    if (param == 'subject') {
      // 专题——AAms
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAms?listID=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/Series?listID=' + idOrUrl
      }
      return
    }
    if (param == 'column') {
      // 专栏——AAmr
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmr?columnistId=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/ColumnDetail?columnistId=' + idOrUrl
      }
      return
    }
    if (param == 'question') {
      // 问题——AAm8
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAm8?docid=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/question?docid=' + idOrUrl
      }
      return
    }
    if (param == 'answer') {
      // 回答——AAmu
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmu?docid=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/answer?docid=' + idOrUrl
      }
      return
    }
    if (param == 'lyhurl') {
      // 原生页链接——AAm9
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAm9?actionurl=' + encodeURIComponent(Base64.encode(idOrUrl))
      } else {
        document.location.href = '#/LyhMLink/lyhurl?actionurl=' + encodeURIComponent(Base64.encode(idOrUrl))
      }
      return
    }
    if (param == 'web') {
      // web链接——AAmJ
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(idOrUrl))
      } else {
        document.location.href = '#/LyhMLink/web?url=' + encodeURIComponent(Base64.encode(idOrUrl))
      }
      return
    }
    if (param == 'PPTDetail') {
      // ppt链接——AAmv
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmv?docid=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/PPTDetail?docid=' + idOrUrl
      }
      return
    }
    if (param == 'DongTaiDetail') {
      // 动态链接——AAmw
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmw?docid=' + idOrUrl
      } else {
        document.location.href = '#/LyhMLink/DongTaiDetail?docid=' + idOrUrl
      }
      return
    }
    if (param == 'home') {
      // app首页——AAmR
      if (belVersion) {
        document.location.href = 'https://bacvcj.jgshare.cn/AAmR'
      } else {
        document.location.href = '#/LyhMLink/home'
      }
      return
    }
  }

  // 其他情况
  document.location.href = 'http://doctor.liangyihui.net/doctor/app.html';
}

// 原代码
// function goappBack(param, id) {

//   if (param) {
//     if (param == 'subjectList') {
//       var actionurl = 'lyh://native.liangyihui.net/allSubjects';
//       document.location.href = 'https://bacvcj.jgshare.cn/AAm9?actionurl=' + encodeURIComponent(Base64.encode(actionurl));
//       return;
//     }
//     if (param == 'columnList56') {
//       var actionurl = 'lyh://native.liangyihui.net/allColumns';
//       document.location.href = 'https://bacvcj.jgshare.cn/AAm9?actionurl=' + encodeURIComponent(Base64.encode(actionurl));
//       return;
//     }
//     //alert(1);
//     if (param == 'doc') {
//       if (id == 38604491) {
//         //PS：测试自几写的极光魔链的
//         console.log('走自定义极光魔链了的')
//         document.location.href = '#/LyhMLink/NewsDetail?docId=38604491'
//         return
//       }
//       document.location.href = 'https://bacvcj.jgshare.cn/AAWj?docid=' + id;
//       return;
//     }
//     if (param == 'live') {
//       document.location.href = 'https://bacvcj.jgshare.cn/AAmI?docid=' + id;
//       return;
//     }
//     if (param == 'column') {
//       document.location.href = 'https://bacvcj.jgshare.cn/AAmr?docid=' + id;
//       // document.location.href = 'https://bacvcj.jgshare.cn/AAmr?columnistId=' + id;
//       // document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(location.href));
//       return;
//     }
//     if (param == 'subject') {
//       document.location.href = 'https://bacvcj.jgshare.cn/AAms?docid=' + id;
//       // document.location.href = 'https://bacvcj.jgshare.cn/AAms?listID=' + id;
//       // document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(location.href));
//       return;
//     }
//     if (param == 'socialextdetail') {
//       document.location.href = 'https://bacvcj.jgshare.cn/AAmw?docid=' + id;
//       // document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(location.href));
//       return;
//     }
//     if (param == 'MyMedalSharePage' || param == 'ShareMedalPage') {
//       //我的勋章 或者 分享的勋章详情页面，打开APP的勋章墙
//       document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(Global_root_path + '/#/MyMedal/0'))
//       return;
//     }

//     if (param == 'DoctorToolsIndex' || param == 'TumorLevel1' || param == 'TumorSelect' || param == 'TumorBluePrintList' || param == 'SelectedTumorPage' || param == 'MyCollectList' || param == 'chemoProject' || param == '2019under35') {
//       document.location.href = 'https://bacvcj.jgshare.cn/AAmJ?url=' + encodeURIComponent(Base64.encode(location.href));
//       return;
//     }
//     if (param == 'answerProjectHome') {
//       let actionurl = 'lyh://native.liangyihui.net/NewWeb?needNotShowShareBtn=1&url=' + Global_root_path + '/#/AnswerQCenter'
//       document.location.href = 'https://bacvcj.jgshare.cn/AAm9?actionurl=' + encodeURIComponent(Base64.encode(actionurl))
//       return
//     }
//   }
//   document.location.href = 'http://doctor.liangyihui.net/doctor/app.html';
// }

function gettimestamp() {
  var timestamp = (new Date()).valueOf();
  return parseInt(timestamp / 1000);

}

function wxshare(wx) {
  let modLink = modifyAmbUrl(wsharep.shareurl)
  let resLink = setUrlPid(modLink)
  let wxSUrl = setUrlSchainAndStid(resLink, 3) // 微信
  let pyqSUrl = setUrlSchainAndStid(resLink, 4) // 朋友圈
  wx.onMenuShareTimeline({
    title: wsharep.sharetitle, // 分享标题
    link: pyqSUrl, // 分享链接
    imgUrl: wsharep.sharepic, // 分享图标
    success: function () {
      //alert(3);

      //alert(1);
      wsharep.successfun();

      // 用户确认分享后执行的回调函数
    },
    cancel: function () {
      //alert(5);
      //successcb();
      // 用户取消分享后执行的回调函数
    }
  });

  wx.onMenuShareAppMessage({
    title: wsharep.sharetitle, // 分享标题
    desc: changeShareDesc(wsharep.sharedesc), // 分享描述
    link: wxSUrl, // 分享链接
    imgUrl: wsharep.sharepic, // 分享图标
    type: '', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    success: function () {
      //alert(4);
      // console.log('分享设置成功-onMenuShareAppMessage')
      //alert(1);
      wsharep.successfun();

      // 用户确认分享后执行的回调函数
    },
    cancel: function () {
      //alert(6);
      // 用户取消分享后执行的回调函数
      // console.log('分享取消-onMenuShareAppMessage')
    },
    fail: function (res) {
      // console.log('分享失败-onMenuShareAppMessage:', res)
    },
    complete: function (res) {
      // console.log('分享完成-onMenuShareAppMessage:', res)
    }
  });

  // JSSDK V1.4 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  wx.updateAppMessageShareData({
    title: wsharep.sharetitle, // 分享标题（1.4.0）
    desc: changeShareDesc(wsharep.sharedesc), // 分享描述
    link: wxSUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: wsharep.sharepic, // 分享图标
    success: function () {
      // 设置成功
      // wsharep.successfun();
      // console.log('分享设置成功-updateAppMessageShareData')
    },
    cancel: function () {
      // console.log('分享取消-updateAppMessageShareData')
    },
    fail: function (res) {
      // console.log('分享失败-updateAppMessageShareData:', res)
    },
    complete: function (res) {
      // console.log('分享完成-updateAppMessageShareData:', res)
    }
  });
  // JSSDK V1.4 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
  wx.updateTimelineShareData({
    title: wsharep.sharetitle, // 分享标题
    link: pyqSUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: wsharep.sharepic, // 分享图标
    success: function () {
      // 设置成功
      // wsharep.successfun();
    }
  });

  //coding提交
}


function getcachejson(apiurl, postdata, cb) {
  var mdstr = apiurl + JSON.stringify(postdata);
  var hash = md5(mdstr);
  var timestamp = Date.parse(new Date()) / 1000;

  localforage.getItem('CACHEMD5_' + hash).then(function (value) {
    if (value.expire > timestamp) {
      cb(value);
    } else {
      cb(0);
    }

  }).catch(function (err) {
    console.log(err);
  });

}

function setcachejson(apiurl, postdata, jsondata, cachetime) {
  var mdstr = apiurl + JSON.stringify(postdata);
  var hash = md5(mdstr);

  var timestamp = Date.parse(new Date()) / 1000;

  jsondata.expire = timestamp + cachetime;

  localforage.setItem('CACHEMD5_' + hash, jsondata).then(function (value) {
    console.log(value);
  }).catch(function (err) {
    console.log(err);
  });


}

/*function wxwebjsk() {

  if (s != 'app') {

    var apiurl = getJskUrl();
    //var url = window.location.href;
    var url = location.href.split('#')[0];
    var reqData = {
      url: url
    }

    $.ajax({
      url: apiurl,
      data: JSON.stringify(reqData),
      type: "POST",
      dataType: 'json',
      contentType: "application/json",
      success: function (data, textStatus, jqXHR) {

        globalstore.dispatch('syncWxInfo', data)

        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'chooseWXPay',
            'chooseImage',
            'closeWindow'
          ],
          openTagList:['wx-open-launch-weapp', 'wx-open-launch-app']
        });

        wx.ready(function () {
          wxshare(wx);
        });

        // wx.error(function (res) {
        //   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        // });


      }
    });
  }
}*/

function setWxJssdkConfig(callBack) {
  var apiurl = `${Global_apiserver}uc/wx/getWxJsSignature`
  var reqData = {
    platForm: 7,
    url: location.href.split('#')[0]
  }

  $.ajax({
    url: apiurl,
    data: JSON.stringify(reqData),
    type: "POST",
    headers: {
      // Authorization: "Basic aDUtZG9jdG9yLWRldjpjMjllMjA1NGIxNDIxYTc0MDRlNTUyYmU2M2VhMmQ1ZA=="
      Authorization: WxJSSDK_Authority
    },
    dataType: 'json',
    contentType: "application/json",
    success: function (res, textStatus, jqXHR) {
      // console.log('微信分享------', res.data)
      let data = res.data
      globalstore.dispatch('syncWxInfo', data)

      console.log('compressjs 设置 wx.config--', location.href)
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'chooseWXPay',
          'chooseImage',
          'closeWindow'
        ],
        openTagList:['wx-open-launch-weapp', 'wx-open-launch-app']
      });

      wx.ready(function () {
        // 安全检查：确保 onSuccess 方法存在再调用
        console.log('compressjs jssdk config OnReady')
        // document.addEventListener('WeixinOpenTagsError', function (e) {
        //   console.error('compressjs 开放标签初始化失败：', e.detail.errMsg);
        // });
        if (callBack && typeof callBack === 'object'
          && callBack.onSuccess && typeof callBack.onSuccess === 'function') {
          callBack.onSuccess()
        }
      });

      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        console.log('compressjs jssdk config 失败:', res)
        // 安全检查：确保 onError 方法存在再调用
        if (callBack && typeof callBack === 'object'
          && callBack.onError && typeof callBack.onError === 'function') {
          callBack.onError(res)
        }
      })


    }
  });
}

function wxwebjsk() {
  if (s != 'app') {
    setWxJssdkConfig({
      onSuccess: function () {
        wxshare(wx);
      },
      onError: function (res) {
        // 微信 JSSDK 配置失败时的错误处理
        console.error('微信 JSSDK 配置失败:', res)
      }
    })
    /*
    var apiurl = `${Global_apiserver}uc/wx/getWxJsSignature`
    var reqData = {
      platForm: 7,
      url: location.href.split('#')[0]
    }

    $.ajax({
      url: apiurl,
      data: JSON.stringify(reqData),
      type: "POST",
      headers: {
        // Authorization: "Basic aDUtZG9jdG9yLWRldjpjMjllMjA1NGIxNDIxYTc0MDRlNTUyYmU2M2VhMmQ1ZA=="
        Authorization: WxJSSDK_Authority
      },
      dataType: 'json',
      contentType: "application/json",
      success: function (res, textStatus, jqXHR) {
        // console.log('微信分享------', res.data)
        let data = res.data

        globalstore.dispatch('syncWxInfo', data)

        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'chooseWXPay',
            'chooseImage',
            'closeWindow'
          ],
          openTagList:['wx-open-launch-weapp', 'wx-open-launch-app']
        });

        wx.ready(function () {
          wxshare(wx);
        });

        wx.error(function(res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
          console.log('微信jssdk配置失败:', res)
        })


      }
    });
 */
  }
}


var eventHub;

/**
 * 注意：此方法会被jsbridge里的同名方法覆盖，两边判断逻辑不一致，嵌套iframe场景 需要注意self == top的判断自行处理
 * 后续迭代优化
 */
function is_app() {
  var ua = navigator.userAgent.toLowerCase();
  //console.log(ua);

  if (ua.match(/LYHApp/i) == "lyhapp" && self == top) {

    s = 'app';

    return true;
  } else {
    s = 'wx';
    //s = 'app';
    return false;
  }
  // consolo.log(s);
}

is_app();

var isminiprogram = false;
var isdoctorweb = false;

function isWxMiniProgram() {
  // isminiprogram = false;
  // isdoctorweb = !is_app();
  // return;
  var ua = window.navigator.userAgent.toLowerCase();
  return new Promise(function (resolve) {
    if (ua.indexOf('micromessenger') == -1) { //不在微信或者小程序中
      resolve(false);
    } else {
      if (wx && wx.miniProgram) {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) { //在小程序中
            resolve(true);
          } else { //在微信中
            resolve(false);
          }
        });
      }
    }
  });
}

isWxMiniProgram().then(function (res) {
  isminiprogram = res;
  isdoctorweb = !res && !is_app();
});

function is_hzzm() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/Trial/i) == "trial") {
    return true;
  } else {
    return false;
  }
}

//alert(s);

function searchjson(arr, value, inkey) {
  var re = -1;
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][inkey] == value) {
      re = i;
      break;
    }
  }
  return re;
}

function JsonSort(json, key) {
  //console.log(json);
  for (var j = 1, jl = json.length; j < jl; j++) {
    var temp = json[j],
      val = temp[key],
      i = j - 1;
    while (i >= 0 && json[i][key] > val) {
      json[i + 1] = json[i];
      i = i - 1;
    }
    json[i + 1] = temp;

  }
  //console.log(json);
  return json;
}
function generateShowShareParam(param,miniProgramImageUrl){
  if(compareVer(head.cver, '9.7.2') > 0) {
    //ios 9.7.2以及之前老版本，分享不可以加参数
    param.userName = wsharep.miniProgramId || undefined
    param.path = wsharep.miniProgramPath || undefined
    param.miniProgramImageUrl = transShareMiniProgramPic(miniProgramImageUrl || wsharep.miniProgramImageUrl)
  }
  return param
}
function transShareMiniProgramPic(imageUrl){
  //微信设计尺寸
  const destWidth = 216
  const ratio = window.devicePixelRatio ? window.devicePixelRatio : 3
  // imageMogr2/thumbnail/648x/format/jpg
  const targetWidth = (destWidth * ratio).toFixed(0)
  //根据宽度缩放，高度自适应并转换为jpg
  return imageUrl ? `${imageUrl}?imageMogr2/thumbnail/${targetWidth}x/format/jpg` : 'https://bosdev.liangyihui.net/share_miniprogram_default_card.png'
}

function global_register() {
  registerfun('shareDoc',
    (data, responseCallback) => {
      let resLink = setUrlPid(wsharep.shareurl)

      if(resLink.indexOf('/doc/') !== -1
        && getHashUrlEndQuery(resLink, 'exactMarketAdType') === '精准营销') {
        //精准营销的广告参数拼接在url的#后，目前列表的精准营销广告都是普通文章形式的。 分享的时候，移除掉精准营销相关的参数
        resLink = deleteUrlQuerys4AnyUrl(resLink, ['exactMarketAdType', 'exactMarketAdLocation', 'exactMarketProductId', 'exactMarketAdId', 'exactMarketAdTitle'])
      }

      let param = {
        param: {
          title: wsharep.sharetitle,
          text: changeShareDesc(wsharep.sharedesc),
          image: wsharep.sharepic,
          url: resLink
        }
      }
      // var type = process.env.MODE
      if(compareVer(head.cver, '9.7.2') > 0) {
      // if(compareVer(head.cver, '9.7.2') > 0 && type !== 'prod') {
        //ios 9.7.2以及之前老版本，分享不可以加参数
        param.param.userName = wsharep.miniProgramId || undefined
        param.param.path = wsharep.miniProgramPath || undefined
        param.param.shareMini = wsharep.shareMini || undefined
        param.param.miniProgramImageUrl = transShareMiniProgramPic(wsharep.miniProgramImageUrl)
        // console.log('shareDoc  miniBase64 == ', wsharep.miniProgramImageBase64)
        param.param.miniProgramImageBase64 = wsharep.miniProgramImageBase64 || undefined
      }
      if(compareVer(head.cver, '9.7.3') > 0) {
        let defbp = {
          content_source: '医生端',
          content_type: '',
          content_id: '',
          product_id: '',
          product_name: ''
        }
        param.param.bp = wsharep.bp || defbp
        param.param.shareCode = wsharep.shareCode || ''
      }
      if (param.param.bp && location.href.indexOf('studyAmbassadorId') != -1) {
        param.param.bp.content_source = '学习大使'
      }
      /*
      //废弃，此处是在分享弹窗弹出来后，就算分享任务完成了，不合理（2023年的活动会影响到，2024年的活动已经在活动内处理了）
      if ((location.href.indexOf('activityJYJ2023') != -1 || location.href.indexOf('activityJYJ2024') != -1) /!*&& localStorage.getItem('shareOption')*!/) {
        if (browser.versions.ios && window.is_app()) {
          if (localStorage.getItem('jyj_index') != 0) {
            JYJ_share()
          } else {
            localStorage.setItem('jyj_index', localStorage.getItem('jyj_index') + 1)
          }
        } else {
          JYJ_share()
        }
      }*/
      console.log('param === ', param);
      responseCallback(param);
    }
  );
  registerfun('setAuth', function (data, responseCallback) {
    var obj = JSON.parse(data);
    //vm.$toast('auth1=' + obj.auth1 + 'auth2=' + obj.auth1);
    //存储起来
    auth1 = obj.auth1;
    auth2 = obj.auth2;

  });
}

function JYJ_share() {
  let matchContent = new URL(window.location.href).hash.split('/')[1].match(/\d+$/) //获取金研奖的活动年份（金研奖的活动链接中的name的格式是：activityJYJ + 年份）
  // let apiurl = Global_apiserver + 'activity/api/GoldAward2024/voteShare'
  let apiurl = Global_apiserver + `activity/api/GoldAward${matchContent && matchContent[0] ? parseInt(matchContent[0]) + 1 :  2024}/voteShare` //接口需要比年份大1，历史原因
        let reqData = {
          head
        }
        $.ajax({
          url: apiurl,
          data: JSON.stringify(reqData),
          type: "POST",
          dataType: 'json',
          async:false,
          contentType: "application/json",
          success: function (data, textStatus, jqXHR) {
            console.log(data);
            if(data.status == 0 && data.result.isTodayFirstShare == true){
              let url = Global_apiserver + 'activity/api/GoldAward2024/userVoteInfo'
              $.ajax({
                url: url,
                data: JSON.stringify(reqData),
                type: "POST",
                dataType: 'json',
                async:false,
                contentType: "application/json",
                success: function (data, textStatus, jqXHR) {
                  console.log(data, '333');
                  window.postMessage({data: {
                    currentVote: data.result.currentVoteCount,
                  }}, location.href)
                }
              })

            } else if (data.status == 0 && data.result.isTodayFirstShare == false) {
              window.postMessage({data: {
                currentVote: false,
              }}, location.href)
            }
          }
        })
}

//时间戳转时间，为适应后台时间戳不是js标准的13位，而是IOS标准的10位
function timeStamp2String(time, format) {

  var nowtime = new Date();
  var myesterday = nowtime.setDate(nowtime.getDate() - 1)
  var yesterday = new Date();
  yesterday.setTime(myesterday);
  var yyear = yesterday.getFullYear();
  var ymonth = yesterday.getMonth() + 1 < 10 ? "0" + (yesterday.getMonth() + 1) : yesterday.getMonth() + 1;
  var ydate = yesterday.getDate() < 10 ? "0" + yesterday.getDate() : yesterday.getDate();


  var nowtime = new Date();
  var nyear = nowtime.getFullYear();
  var nmonth = nowtime.getMonth() + 1 < 10 ? "0" + (nowtime.getMonth() + 1) : nowtime.getMonth() + 1;
  var ndate = nowtime.getDate() < 10 ? "0" + nowtime.getDate() : nowtime.getDate();


  var datetime = new Date();
  datetime.setTime(time * 1000);
  var year = datetime.getFullYear();
  var noCentryYear = '';//年份的后两位
  if (year > 2000) {
    noCentryYear = datetime.getYear() - 100;
  }
  var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
  var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime
    .getDate();
  var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime
    .getHours();
  var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
  var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
  var re = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  var week = datetime.getDay();
  var weekday = new Array(7)
  weekday[0] = "日"
  weekday[1] = "一"
  weekday[2] = "二"
  weekday[3] = "三"
  weekday[4] = "四"
  weekday[5] = "五"
  weekday[6] = "六"
  if (format != null && format == 'all') {
    re = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  } else if (format != null && format == 'l') {
    re = year + "-" + month + "-" + date + " " + hour + ":" + minute;
  } else if (format != null && format == 'sl') {
    re = year.toString().substring(2) + "-" + month + "-" + date + " " + hour + ":" + minute;
  } else if (format != null && format == 'sd') {
    re = year + "-" + month + "-" + date;
  } else if (format != null && format == 's') {
    if (yyear == year && ymonth == month && ydate == date) {
      re = "昨天" + " " + hour + ":" + minute;
    } else if (nyear == year && nmonth == month && ndate == date) {
      re = hour + ":" + minute;
    } else if (nyear == year) {
      re = month + "-" + date + " " + hour + ":" + minute;
    } else {
      re = year + "-" + month + "-" + date + " " + hour + ":" + minute;
    }
  } else if (format != null && format == 'timeFormat1') {
    if (nyear == year && nmonth == month && ndate == date) {
      re = "今天 " + hour + ":" + minute;
    } else if (nyear == year) {
      re = month + "-" + date + " " + hour + ":" + minute;
    } else {
      re = year + "-" + month + "-" + date + " " + hour + ":" + minute;
    }
  } else if (format != null && format == 'timeFormat2') {
    if (nyear == year) {
      re = month + "-" + date + " " + hour + ":" + minute;
    } else {
      re = year + "-" + month + "-" + date + " " + hour + ":" + minute;
    }
  } else if (format != null && format == 'd') {
    re = year + "-" + month + "-" + date;
  } else if (format != null && format == 'Y') {
    re = year;
  } else if (format != null && format == 'Hi') {
    re = hour + ":" + minute;
  } else if (format != null && format == 'md') {
    re = year + "-" + month;
  } else if (format != null && format == 'md2') {
    re = month + "月" + date + '日';
  } else if (format != null && format == 'w') {
    re = "周" + weekday[week];
  } else if (format != null && format == 'ny4subjectlist') {
    //样式：
    // 1、今年的日期显示为： 今天、昨天、月日
    // 2、往年的日期显示为：年月日

    var now = new Date();

    if (datetime.getFullYear() == now.getFullYear()) {
      //同一年
      if (now.getMonth() == datetime.getMonth()) {
        //同一月
        var daydef = now.getDate() - datetime.getDate();
        if (daydef == 0) {
          //今天
          re = "今天";
        } else if (daydef == 1) {
          //昨天
          re = "昨天";
        } else if (daydef == -1) {
          re = "明天";
        } else {
          //月日
          re = month + "-" + date;
        }
      } else {
        //非 同一月
        re = month + "-" + date;
      }


    } else {
      //不是同一年，显示为：年月日
      re = year + "-" + month + "-" + date;
    }

  } else if (format != null && format == 'afda') {
    //几天前
    var time = parseInt(new Date().getTime() / 1000) - time;
    var day = time / 86400;
    if (parseInt(day)) {
      re = parseInt(day) + '天前';
    } else {
      var hour = (time % 86400) / 3600;
      if (parseInt(hour)) {
        re = parseInt(hour) + '小时前'
      } else {
        var mint = (time % 3600) / 60;
        if (parseInt(mint)) {
          re = parseInt(mint) + '分钟前'
        } else {
          re = '刚刚'
        }
      }
    }
  } else if (format != null && format == 'sb') {
    //几天前
    var time = parseInt(new Date().getTime() / 1000) - time;
    var day = time / 86400;
    if (parseInt(day)) {
      if (parseInt(day) == 1) {
        re = '昨天';
      } else if (parseInt(day)) {
        var now = new Date();
        if (datetime.getFullYear() == now.getFullYear()) {
          re = month + "-" + date;
        } else {
          //不是同一年，显示为：年月日
          re = year + "-" + month + "-" + date;
        }
      }
    } else {
      var hour = (time % 86400) / 3600;
      if (parseInt(hour)) {
        re = parseInt(hour) + '小时前'
      } else {
        var mint = (time % 3600) / 60;
        if (parseInt(mint)) {
          re = parseInt(mint) + '分钟前'
        } else {
          re = '刚刚'
        }
      }
    }
  } else if (format != null && format == 'ambMsg') {
    //样式：
    // 当日推送的消息，按照时分显示，如09:56；
    // 超过当天按照月日显示，如03-06；
    // 超过当年的，按照年月日显示，如2023-12-26

    var now = new Date();

    if (datetime.getFullYear() == now.getFullYear()) {
      //同一年
      if (now.getMonth() == datetime.getMonth()) {
        //同一月
        var daydef = now.getDate() - datetime.getDate();
        if (daydef == 0) {
          //今天
          re = `${hour}:${minute}`;
        }else {
          //月日
          re = month + "-" + date;
        }
      } else {
        //非 同一月
        re = month + "-" + date;
      }


    } else {
      //不是同一年，显示为：年月日
      re = year + "-" + month + "-" + date;
    }

  } else if (format != null && format == 'aicase') {
    //样式：
    // 当日： 今天
    // 超过当天按照月日显示，如03-06；
    // 超过当年的，按照年月日显示，如2023-12-26

    var now = new Date();

    if (datetime.getFullYear() == now.getFullYear()) {
      //同一年
      if (now.getMonth() == datetime.getMonth()) {
        //同一月
        var daydef = now.getDate() - datetime.getDate();
        if (daydef == 0) {
          //今天
          re = '今天';
        }else {
          //月日
          re = month + "-" + date;
        }
      } else {
        //非 同一月
        re = month + "-" + date;
      }


    } else {
      //不是同一年，显示为：年月日
      re = year + "-" + month + "-" + date;
    }
  }

  if (year && format === 'yy.MM.dd') {
    var full_year = year + '';
    var sYear = full_year.substr(2, 2);
    re = sYear + '.' + month + '.' + date;
  } else if (year && format === 'yyyy.MM.dd') {
    re = year + '.' + month + '.' + date;
  } else if (year && format === 'yyyy年MM月dd日') {
    var full_year = year + '';
    re = full_year + '年' + month + '月' + date + '日';
  } else if (year && format === 'yyyy/MM/dd') {
    var full_year = year + '';
    re = full_year + '/' + month + '/' + date;
  } else if (year && format === 'yy/MM/dd') {
    var full_year = year + '';
    var two_Year = full_year.substr(2, 2);
    re = two_Year + '/' + month + '/' + date;
  } else if (year && format === 'yy年MM月dd日 hh:mm') {
    re = noCentryYear + '年' + month + '月' + date + '日' + hour + ':' + minute;
  } else if (year && format === 'MM月dd日 hh:mm') {
    re = month + '月' + date + '日' + hour + ':' + minute;
  }

  return re;
}

// 将秒数转换为时分秒
function secondsToHms_Integer(totalSeconds) {
    const integerSeconds = Math.floor(totalSeconds);
    if (typeof integerSeconds !== 'number' || integerSeconds < 0) {
        return "00:00:00";
    }
    const hours = Math.floor(integerSeconds / 3600);
    const minutes = Math.floor((integerSeconds % 3600) / 60);
    const seconds = integerSeconds % 60;
    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

// 获取医院类别与等级
function getHospitalCategoryLevel(category, level) {
  var cStr = '';
  var lStr = '';
  switch (category) {
    case 1:
      cStr = '综合医院';
      break;
    case 2:
      cStr = '妇产医院';
      break;
    case 3:
      cStr = '儿童医院';
      break;
    case 4:
      cStr = '眼科医院';
      break;
    case 5:
      cStr = '口腔医院';
      break;
    case 6:
      cStr = '五官医院';
      break;
    case 7:
      cStr = '肿瘤医院';
      break;
    case 8:
      cStr = '骨科医院';
      break;
    case 9:
      cStr = '精神病医院';
      break;
    case 10:
      cStr = '传染病医院';
      break;
    case 11:
      cStr = '中医医院';
      break;
    case 12:
      cStr = '康复医院';
      break;
    case 13:
      cStr = '胸科医院';
      break;
    default:
      cStr = '其他医院';
      break;
  }
  switch (level) {
    case 1:
      lStr = '三级特等';
      break;
    case 2:
      lStr = '三甲';
      break;
    case 3:
      lStr = '三乙';
      break;
    case 4:
      lStr = '三丙';
      break;
    case 5:
      lStr = '二甲';
      break;
    case 6:
      lStr = '二乙';
      break;
    case 7:
      lStr = '二丙';
      break;
    case 8:
      lStr = '一甲';
      break;
    case 9:
      lStr = '一乙';
      break;
    case 10:
      lStr = '一丙';
      break;
    default:
      lStr = '';
      break;
  }
  return lStr + (lStr.length ? ' ' : '') + cStr;
}

/**
 * JavaScript实现版本号比较
 * 传入两个字符串，当前版本号：curV；比较版本号：reqV
 * 调用方法举例：Version('5.12.3','5.12.2')，将返回true
 * Version('5.12.3','5.12.2')
 */
function compareVer(curV, reqV) { // curV -1 旧版 0 相等 1 新版
  var arr1 = curV.split('.');
  var arr2 = reqV.split('.');
  //将两个版本号拆成数字
  var minL = Math.min(arr1.length, arr2.length);
  var pos = 0; //当前比较位
  var diff = 0; //当前为位比较是否相等

  //逐个比较如果当前位相等则继续比较下一位
  while (pos < minL) {
    diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
    if (diff != 0) {
      break;
    }
    pos++;
  }

  if (diff > 0) {
    console.log('新版本')
    return 1;
  } else if (diff == 0) {
    console.log('稳定版')
    return arr1.length - arr2.length; //应对9.2和9.2.1版本进行比较的情况
  } else {
    console.log('旧版本')
    return -1;
  }
}

//腾讯旧视频中转
function changeoldvedio(rdt) {
  if (rdt && rdt.match(/<p\sid=\"vedio\"/g)) {
    if (browser.versions.android) {
      rdt = rdt.replace(/(<p\sid=\"vedio\"\svid=\"(.*?)\")/ig, '<iframe src="http://v.qq.com/iframe/player.html?vid=$2&auto=0" frameborder="0" allowfullscreen=""></iframe>$1');
    } else {
      rdt = rdt.replace(/(<p\sid=\"vedio\"\svid=\"(.*?)\")/ig, '<iframe src="https://v.qq.com/iframe/player.html?vid=$2&auto=0" frameborder="0" allowfullscreen=""></iframe>$1');
    }
  }
  return rdt;
}

function removeHTMLTag(str) {

  if (str) {
    str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
    str = str.replace(/&nbsp;/ig, ''); //去掉&nbsp;
  }
  return str;
}

function gourl(url, router) {
  document.location.href = url;
}

function gotoLoginHint(router,sendjson) {
  if (is_app()) {
    if(sendjson) {
      nativefun('gotoLoginHint',{
        'param': sendjson
      })
    } else{
      nativefun('gotoLoginHint')
    }
  } else {
    /**
     router.push({
      name: 'Auth',
      params: { id: 1 }
    })*/
  }
}

function gotoCertifyHint(router, sendjson) {

  var params = {};
  if (sendjson) {
    var params = {
      'param': {
        'privilageCode': sendjson.privilageCode,
        'privilageMsg': sendjson.privilageMsg,
        'docId':sendjson.docId || 0
      }
    };
  }
  if(is_app() &&  browser.versions.android){
    //Android
    const userObj = head.extensions.find((e)=>e.name=='userType')
    //已选择身份,跳转认证
    if(userObj && userObj.value > 0) {
      nativefun('gotoCertifyHint', params, function (responseData) {
      });
    }else{
      //未选择身份
      return
    }
  }else if(is_app()){
    //iOS
    console.log("gotoCertifyHint1")
    //$.alert('gotoCertifyHint');
    nativefun('gotoCertifyHint', params, function (responseData) {
    });
  }
  return;

}

function gotoFocusColumn(res,router) {
  let columnists = []
  if(router.name == 'doc' || router.name == 'DocPreviewNew' || router.name == 'live' || router.name == 'LivePreviewNew' || router.name == '2024answerLive' || router.name == '2024answerDoc'){
    if(res.basic && res.basic.docId) {
      const apiurl = Global_apiserver + 'api/dt/v2/getDrDocColumnists'
      const reqData = { head, docId:res.basic.docId }
      $.ajax({
        url: apiurl,
        data: JSON.stringify(reqData),
        type: "POST",
        dataType: 'json',
        async:false,
        contentType: "application/json",
        success: function (data, textStatus, jqXHR) {
          if(data.responseStatus.ack == 0){
            if(data.columnists && data.columnists.length){
              columnists = data.columnists
            }
          }
        }
      })
    }
  }else{
    columnists = res.columnists || []
  }
  if (!columnists || !columnists.length) {
    return;
  }
  // let column = res.columnists[0];
  window.globalstore.commit("SAVE_DOC_FOCUS_COLUMN", columnists);
}

function checkStatus(res, router) {
  var privilageCode = res.basic.privilageCode;
  var privilageMsg = res.basic.privilageMsg;
  var docId = res.basic && res.basic.docId || 0

  //保存错误信息 兼容老版本
  window.globalstore.commit("SAVE_PRIVI", {
    privilageCode: privilageCode,
    privilageMsg: privilageMsg
  });

  console.log('privilageCode=>' + privilageCode);
  console.log('privilageMsg=>' + privilageMsg);
  if (privilageCode != 0) {
    switch (privilageCode) {
      case 0:
        return 0;
        break;
      case 70: { //去登录
        gotoLoginHint(router,{bp: {page_source:`registerlogin_doc_${docId}`,page_source_url: self.location.href}});
        return 70;
        break;
      }
      case 71:
        gotoCertifyHint(router, {privilageCode: privilageCode, privilageMsg: privilageMsg, docId: docId});
        return 71;
        break;
      case 73:
        gotoCertifyHint(router, {privilageCode: privilageCode, privilageMsg: privilageMsg, docId: docId});
        return 73;
        break;
      case 76:
        console.log(router)
        gotoFocusColumn(res,router);
        return 76;
        break;
      case 78:
        return 78;
        break;
      default:
        break;
    }
    return 1;
  } else {
    return 0;
  }
}

function goDoc(docId, docType, documentDetailUrl, router, isIntegralDocument) {

  console.log('调用goDoc', docId, docType, router, isIntegralDocument);
  //isIntegralDocument判断是否是积分文章，积分文章跳转integralDoc/integralLive 进入页面15秒后调用原生完成任务方法(getDoneMission)
  if (is_app()) { //原生
    //$.alert('app');
    nativefun('goToDocument', {
      'param': {
        'docId': docId,
        'docType': docType,
        'documentDetailUrl': documentDetailUrl
      }
    }, function (responseData) {
    });

    //this.$router.push({ name: 'doc', params: { id: docId }})
  } else {
    //$.alert('wx');
    //var docType = this.value.docType;
    if (isLiveClass(docType)) {
      // document.location.href = Global_root_path + 'doctor/live.html?id=' + docId;
      //alert(1);
      if (documentDetailUrl) {
        //因为有的埋点参数会放在url后面，故有url的话，直接加载url，否则通过下面的push方式会导致埋点参数丢失
        var tempUrl = documentDetailUrl
        if (isIntegralDocument && tempUrl.indexOf('/live') != -1) {
          tempUrl.replace('/live', '/integralLive')
        }

        location.href = tempUrl;
      } else {
        router.push({
          name: isIntegralDocument ? 'integralLive' : 'live',
          params: {
            id: docId
          }
        });
      }

    } else {

      console.log('跳文章');
      if (documentDetailUrl) {
        //因为有的埋点参数会放在url后面，故有url的话，直接加载url，否则通过下面的push方式会导致埋点参数丢失
        var tempUrl = documentDetailUrl
        if (isIntegralDocument && tempUrl.indexOf('/doc') != -1) {
          tempUrl.replace('/doc', '/integralDoc')
        }

        location.href = tempUrl;
      } else {
        router.push({
          name: isIntegralDocument ? 'integralDoc' : 'doc',
          params: {
            id: docId
          }
        })
      }
    }
  }
}
/**
 * 文章是否是公开课
 * @param docType 文章类型
 */
function isLiveClass(docType) {
  return docType == 6 || docType == 9 || docType == 25 || docType == 30 || docType == 44
}

function goSubject(subjectId, router) {

  if (is_app()) {
    nativefun('goToSubject', {
      'param': subjectId
    }, function (responseData) {
    });
  } else {
    router.push({
      name: 'subject',
      params: {
        id: subjectId
      }
    })
  }
}

function goColunm(colunmId, router) {

  if (is_app()) {
    nativefun('goToColumnDetail', {
      'param': colunmId
    }, function (responseData) {
    });
  } else {
    router.push({
      name: 'column',
      params: {
        id: colunmId
      }
    })
  }
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["ArkWeb","LYHAPP","Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod", "LYHApp"
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag;
}


function webrouter(robj, vparams) {

  var name = robj.name;
  var path = robj.path;

  var url = window.location.href;
  //alert(url);

  // var apiurl = Global_nodeserver + '/tools/getsavekey';
  var apiurl = Global_AliJson_path + 'web_route_map';
  // var reqData = {
  //   "savekey": "web_route_map",
  //   "type": "json"
  // };
  var newurl;
  $.ajax({
    url: apiurl,
    // data: JSON.stringify(reqData),
    type: "GET",
    dataType: 'json',
    contentType: "application/json",
    success: function (data, textStatus, jqXHR) {
      var mapjson = data.items;

      var item = mapjson[searchjson(mapjson, name, 'mkey')]; //配置json
      newurl = item.purl; //pc url 模板
      var kparams = item.params; // 参数数组

      if (kparams && kparams.length >= 1) {

        for (var i = 0; i < kparams.length; i++) {
          //http://www.liangyihui.net/doc/{id}
          var key = kparams[i]; //参数项
          newurl = newurl.replace('{' + key + '}', vparams[key]);
        }
      }
      gourl(newurl);
    }
  });

}

function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

$(document).ready(function () {
  /*
        if(s != 'app') {
            var body = document.getElementsByTagName('body')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'http://doctor.liangyihui.net/count.js';
            body.appendChild(script);
        }
    */
});

// var pb1, picitems, pbisopen;

function setpb(i) {
  window.pb1 = $.photoBrowser({
    items: window.picitems,
    initIndex: i,
    onOpen: function () {
      window.pbisopen = 1;
      // console.log("onOpen", this);
      //console.log(this);
      //pb1.slideTo(this.activeIndex);
    },
    onClose: function () {
      window.pbisopen = 0;
      // console.log("onClose", this);
    }
  });
}

(function ($) {
  $.getUrlParam = function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }
})(jQuery);

/*
 * 功能：生成一个GUID码，其中GUID以14个以下的日期时间及18个以上的16进制随机数组成，GUID存在一定的重复概率，但重复概率极低，理论上重复概率为每10ms有1/(16^18)，即16的18次方分之1，重复概率低至可忽略不计
 * 免责声明：此代码为作者学习专用，如在使用者在使用过程中因代码问题造成的损失，与作者没有任何关系
 * 日期：2014年9月4日
 * 作者：wyc
 */

function GUID() {
  this.date = new Date();

  /* 判断是否初始化过，如果初始化过以下代码，则以下代码将不再执行，实际中只执行一次 */
  if (typeof this.newGUID != 'function') {

    /* 生成GUID码 */
    GUID.prototype.newGUID = function () {
      this.date = new Date();
      var guidStr = '';
      sexadecimalDate = this.hexadecimal(this.getGUIDDate(), 16);
      sexadecimalTime = this.hexadecimal(this.getGUIDTime(), 16);
      for (var i = 0; i < 9; i++) {
        guidStr += Math.floor(Math.random() * 16).toString(16);
      }
      guidStr += sexadecimalDate;
      guidStr += sexadecimalTime;
      while (guidStr.length < 32) {
        guidStr += Math.floor(Math.random() * 16).toString(16);
      }
      return this.formatGUID(guidStr);
    }

    /*
     * 功能：获取当前日期的GUID格式，即8位数的日期：19700101
     * 返回值：返回GUID日期格式的字条串
     */
    GUID.prototype.getGUIDDate = function () {
      return this.date.getFullYear() + this.addZero(this.date.getMonth() + 1) + this.addZero(this.date.getDay());
    }

    /*
     * 功能：获取当前时间的GUID格式，即8位数的时间，包括毫秒，毫秒为2位数：12300933
     * 返回值：返回GUID日期格式的字条串
     */
    GUID.prototype.getGUIDTime = function () {
      return this.addZero(this.date.getHours()) + this.addZero(this.date.getMinutes()) + this.addZero(this.date.getSeconds()) + this.addZero(parseInt(this.date.getMilliseconds() / 10));
    }

    /*
     * 功能: 为一位数的正整数前面添加0，如果是可以转成非NaN数字的字符串也可以实现
     * 参数: 参数表示准备再前面添加0的数字或可以转换成数字的字符串
     * 返回值: 如果符合条件，返回添加0后的字条串类型，否则返回自身的字符串
     */
    GUID.prototype.addZero = function (num) {
      if (Number(num).toString() != 'NaN' && num >= 0 && num < 10) {
        return '0' + Math.floor(num);
      } else {
        return num.toString();
      }
    }

    /*
     * 功能：将y进制的数值，转换为x进制的数值
     * 参数：第1个参数表示欲转换的数值；第2个参数表示欲转换的进制；第3个参数可选，表示当前的进制数，如不写则为10
     * 返回值：返回转换后的字符串
     */
    GUID.prototype.hexadecimal = function (num, x, y) {
      if (y != undefined) {
        return parseInt(num.toString(), y).toString(x);
      } else {
        return parseInt(num.toString()).toString(x);
      }
    }

    /*
     * 功能：格式化32位的字符串为GUID模式的字符串
     * 参数：第1个参数表示32位的字符串
     * 返回值：标准GUID格式的字符串
     */
    GUID.prototype.formatGUID = function (guidStr) {
      var str1 = guidStr.slice(0, 8) + '-',
        str2 = guidStr.slice(8, 12) + '-',
        str3 = guidStr.slice(12, 16) + '-',
        str4 = guidStr.slice(16, 20) + '-',
        str5 = guidStr.slice(20);
      return str1 + str2 + str3 + str4 + str5;
    }
  }
}

//判断是否存在指定函数
function isExitsFunction(funcName) {
  try {
    if (typeof (eval(funcName)) == "function") {
      return true;
    }
  } catch (e) {
  }
  return false;
}

//显示滑动大图
function bigpic(i) {
  setpb(i);
  if (!window.pbisopen || (window.pbisopen !== 1)) {
    // console.log("pb1.open");
    window.pbisopen = 1;
    window.pb1.open();
  }
}

$(function () {
  // FastClick.attach(document.body);
});
//_V_.options.flash.swf = "/static/videojs/video-js.swf";
// 因遇到百度统计js加载失败，移除百度统计
// var _hmt = _hmt || [];
// var baiduscripturl;

// if (!is_app()) {
//   //alert('不是APP');
//   baiduscripturl = "https://hm.baidu.com/hm.js?96241501d615ff3fb7d5ce875c13c4e1";
// } else {
//   if (is_hzzm()) {
//     //alert('患者招募');
//     baiduscripturl = "https://hm.baidu.com/hm.js?563c876fc826129044d8af534206c2a1"; //在患者招募app里
//   } else {
//     //alert('普通');
//     baiduscripturl = "https://hm.baidu.com/hm.js?526a78b5a1e60ba6f6875a592d5bbade"; //在通用app里
//   }
// }

// (function () {
//   //_hmt.push(['_setAutoPageview', false]);
//   var hm = document.createElement("script");
//   hm.src = baiduscripturl;
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);

// })();

/*
 "head": {
		"auth": "",
		"cid": "",
        "cver": "3.4",
        "sid": "",
		"extensions": [{
			"name": "platform",
			"value": ""
		}],
	},
  */

var mdjson = {
  head: head,
  "sessionId": "",
  "buriedItems": [{
    "actionType": 0,
    "targetObject": "",
    "params": [
      "0"
    ],
    "currentTime": 1494393817,
    "contentType": 0
  }]
}

var guid = (new GUID()).newGUID(); //alert(guid.newGUID());
//mdjson.head.auth = auth1;
mdjson.sessionId = guid;


//Android
//PC
//wechat

//if(is_app()) {
//	if(browser.versions.android) {
//		mdjson.head.extensions[0].value = 'Android';
//	} else {
//		mdjson.head.extensions[0].value = 'iOS';
//	}
//} else {
if (is_weixin()) {
  //mdjson.head.extensions[0].value = 'wechat';
}


//折叠处理
var Accordion = function (el) {
  this.el = el || {};

  var links = this.el.find('.zn_link');
  //var target = this.el.find('.zn_link .fa');
  links.on('click', {
    el: this.el
  }, this.dropdown)

}

var $prevn;
var $prevt;

var thiskey;
var prekey;

Accordion.prototype.dropdown = function (e) {

  var $el = e.data.el,
    $this = $(this),
    $next = $this.next();
  if ($next.hasClass("zn_content")) {

    $next.stop().slideToggle();
    $this.toggleClass('open');

    thiskey = $(this).attr('key');

    if (prekey) {
      if (thiskey != prekey) {
        $(".zn_content[key='" + prekey + "']").hide();
        $(".zn_link[key='" + prekey + "']").removeClass('open');
      }
    }
    prekey = thiskey;
  }
}

function docAccordion() {

  if ($('#article').find("h6")) {
    $('#article').wrap("<div class='patientGuide'></div>");
    $('#article').wrapInner("<div id='accordion' class='accordion'></div>");

  }
  // 包裹元素 处理头部
  $('#accordion').find("h6").each(function (item) {
    $(this).wrap("<div class='zn_link'></div>")
    var $dom = $("<em class='fa fa-chevron-down'></em>");
    $(this).append($dom);
  })

  //处理文章
  $('.zn_link').each(function (index) {
    $(this).attr('key', index);
    var $dom = $("<div class='zn_content' key='" + index + "'></div>")
    $(this).nextUntil('.zn_link').wrapAll($dom);
  })

  $('#accordion h6:even').css('background-color', 'rgba(244,244,250,1)');
  $('#accordion h6:odd').css('background-color', 'rgba(235,235,249,1)');

  // new accordion
  var accordion = new Accordion($('#accordion'));
}

function getMonthDays(lastMonth) {
  var now = new Date(); //当前日期
  var nowYear = now.getYear(); //当前年
  var monthStartDate = new Date(nowYear, lastMonth, 1);
  var monthEndDate = new Date(nowYear, lastMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}

//获取上个月的第一天的时间戳
function lastmonthStartTime() {

  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  console.log(nowYear)
  var lastMonthDate = new Date(); //上月日期
  lastMonthDate.setDate(1);
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  var lastMonth = lastMonthDate.getMonth();

  console.log(lastMonth);
  if (lastMonth == 11) {
    nowYear = nowYear - 1
  }

  //获得上月开始时间
  var lastMonthStartDate = new Date(nowYear, lastMonth, 1);

  console.log(lastMonthStartDate);

  var formatMonth = (new Date(lastMonthStartDate).getMonth() + 1) < 10 ? "0" + (new Date(lastMonthStartDate).getMonth() + 1) : new Date(lastMonthStartDate).getMonth() + 1;
  var formatDate = new Date(lastMonthStartDate).getDate() < 10 ? "0" + new Date(lastMonthStartDate).getDate() : new Date(lastMonthStartDate).getDate();
  var lastStartTime = new Date(lastMonthStartDate);
  return Date.parse(lastStartTime) / 1000;
}

//获取上个月的最后一天的时间戳
function lastmonthEndTime() {
  var now = new Date(); //当前日期
  var nowYear = now.getFullYear(); //当前年
  var lastMonthDate = new Date(); //上月日期
  lastMonthDate.setDate(1);
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  var lastMonth = lastMonthDate.getMonth();

  if (lastMonth == 11) {
    nowYear = nowYear - 1
  }
  var lastMonthEndDate = new Date(nowYear, lastMonth, this.getMonthDays(lastMonth));
  var formatEndMonth = (new Date(lastMonthEndDate).getMonth() + 1) < 10 ? "0" + (new Date(lastMonthEndDate).getMonth() + 1) : new Date(lastMonthEndDate).getMonth() + 1;
  var formatEndDate = new Date(lastMonthEndDate).getDate() < 10 ? "0" + new Date(lastMonthEndDate).getDate() : new Date(lastMonthEndDate).getDate();
  var lastEndTime = new Date(lastMonthEndDate).getFullYear() + '-' + formatEndMonth + '-' + formatEndDate;

  return Date.parse(lastEndTime) / 1000 - 28800;
}

function setaliyunmaidian(funname) {
  var uuid = '';
  var userinfo = {
    mobile: '',
    gender: '',
    level: '',
    type: '',
    hospital: '',
    department: '',
    jobtitle: '',
  };

  if (localStorage.getItem('LYHUUID')) {
    uuid = localStorage.getItem('LYHUUID')
  }
  if (sessionStorage.getItem('userinfoobjstr')) {
    userinfo = JSON.parse(sessionStorage.getItem('userinfoobjstr'));
  }

  var laiyuan = is_app() ? 'app' : 'wx';

  if (browser.versions.android) {
    laiyuan = laiyuan + '_Android';
  }

  if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
    laiyuan = laiyuan + '_iOS';
  }
  //console.log(browser);

  var aliyunmd = {
    laiyuan: laiyuan,
    uuid: uuid,
    funname: funname,
    mobile: userinfo.mobile,
    gender: userinfo.gender,
    level: userinfo.level,
    type: userinfo.type,
    hospital: userinfo.hospital,
    department: userinfo.department,
    jobtitle: userinfo.jobtitle,
    env: Global_apiserver.indexOf('demohdtapi.liangyihui.net') > 0 ? 'dev' : 'prod'
  };
  aliyunlog(aliyunmd);
}

function judgeNumIsTel(num) {
  //判断手机号码是否有效
  // var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  var myreg = /^[1][3456789]\d{9}$/;
  if (!myreg.test(num)) {
    //不是有效的电话号码
    return false;
  } else {
    return true;
  }
}

// appv8.7之前不兼容setPageSource,getPageSource方法
//h5发送前置页面数据到Native
function setPageSource(key, data) { //key神策事件英文变量,需要Native帮助保存的数据,如需保存前置页面可以直接传页面名称（string）
  if (is_app()) {
    nativefun('BuriedPoint', {
      "type": "SA",
      "key": `${key}`,
      "method": "setPageSource",
      "data": typeof (data) == 'string' ? {"source": data} : data
    })
  }
}

//h5发送Native方法获取前置页面
function getPageSource(key) { //key神策事件英文变量
  if (is_app()) {
    return new Promise((resolve, reject) => {
      nativefun('BuriedPoint', {"type": "SA", "key": `${key}`, "method": "getPageSource"}, (responseData) => {
        if (responseData) {
          resolve(JSON.parse(responseData))
        } else {
          reject(false)
        }
      })
    })
  }

}

//h5发送前置页面数据到Native
function setPageContent(key, data) { //key神策事件英文变量,需要Native帮助保存的数据
  if (is_app()) {
    nativefun('BuriedPoint', {"type": "SA", "key": `${key}`, "method": "setPageContent", "data": data})
  }
}

//h5发送Native方法获取前置页面
function getPageContent(key) { //key神策事件英文变量
  if (is_app()) {
    return new Promise((resolve, reject) => {
      nativefun('BuriedPoint', {"type": "SA", "key": `${key}`, "method": "getPageContent"}, (responseData) => {
        if (responseData) {
          resolve(JSON.parse(responseData))
        } else {
          reject(false)
        }
      })
    })
  }

}

function registerPageContent(key, callBack) {
  registerfun('BuriedPoint',
    (req, responseCallback) => {
      // {"type":"SA","key":`${key}`,"method":"setPageContent","data": STRING || obj}
      // {"type": "SA", "key": `${key}`, "method": "getPageContent"},(responseData) => {}
      let reqData = JSON.parse(req)
      if (key == 'PassageButtonClick') {
        if (reqData.method == 'setPageContent') {
          callBack(reqData)
        }
      } else if (key == 'LiveButtonClick') {
        if (reqData.method == 'setPageContent') {
          callBack(reqData)
        }
      }
    })
}

/**
 * 埋点：订阅
 * @param position feed流、内容详情页、专栏主页
 * @param title 例：专家姓名、专栏名称
 * @param id 例：专栏ID
 */
function bpFollow(root, position, title, id) {
  var bp = {
    position: position,
    follow_title: title,
    follow_id: id,
    follow_type: '专栏',
  }
  root.getSensorsTrackFunction('Follow', bp)
}

function modDocTypeName(docType) {
  switch (docType) {
    case 1:
      return '普通文章'
    case 6:
      return '公开课'
    case 9:
      return '公开课预告'
    case 25:
      return '会议直播'
    case 29:
      return '会议文章'
    case 30:
      return '病例直播'
    case 51:
      return '病例分享'
    case 52:
      return '病例分享'

    default:
      return ''
  }
}

/**
 * 获取url中的渠道信息
 * https://liangyihui.feishu.cn/wiki/wikcnZyfid2X4Oy3ad1T85d9VFf
 * @param currentUrl
 * @returns {string|number}
 */
function getContentChannel(currentUrl) {
  if (!getSearchParams(currentUrl, 'cc')) {
    return 1
  } else {
    return getSearchParams(currentUrl, 'cc')
  }
}

/**
 * 获取url中的传播者信息
 * https://liangyihui.feishu.cn/wiki/wikcnZyfid2X4Oy3ad1T85d9VFf
 * @param currentUrl
 * @returns {string}
 */
function getPid(currentUrl) {
  return getSearchParams(currentUrl, 'pid')
}

/**
 * 获取带#的url中#后面的query的key对应的值，若是要获取#之前的query，则直接用getSearchParams即可
 * @param currentUrl
 * @param key query对应的key值
 * @returns {string}
 */
function getHashUrlEndQuery(currentUrl, key) {
  if (currentUrl.indexOf('#/') === -1) {
    //url中没有#，直接获取query
    return getSearchParams(currentUrl, key)
  } else {
    let tempPre= "https://test.liangyihui.net/" //假的链接,为了移除url链接中的#
    let urlSplit = currentUrl.split('#/')
    if (urlSplit.length > 1 && urlSplit[1]) {
      return getSearchParams(`${tempPre}${urlSplit[1]}`, key)
    }

    return ''
  }
}

/**
 * 根据key，获取url中的value
 * @param currentUrl
 * @param key
 * @returns {string}
 */
function getSearchParams(currentUrl, key) {
  /* start 解决零宽空格导致new URL(url)报错的问题 */
  const newUrl = decodeURI(encodeURI(currentUrl).replace(/%E2%80%8B/g, ''))
  /* end 解决零宽空格导致new URL(url)报错的问题 */
  const url = new URL(newUrl)
  return url.searchParams.get(key)
}
/**
 * 获取url中的mcode参数
 * @param currentUrl
 * @returns {string}
 */
function getMCode(currentUrl) {
  return getSearchParams(currentUrl, 'mcode')
}


function refactorUrl(currentUrl,nativeHandler,param){
  switch(nativeHandler){
    case 'goToColumnDetail':
      if (compareVer(head.cver, '9.5.5') === -1) {
        nativefun('goToColumnDetail', param, function (responseData) {});
      }else{
        // const currentUrl = 'https://demom.liangyihui.net/?mcode=task_125_125&page_source=task#/columnList56';
        const newUrl = decodeURI(encodeURI(currentUrl).replace(/%E2%80%8B/g, ''))
        const url = new URL(newUrl);
        const nextUrl = new URL(`lyh://native.liangyihui.net/ColumnDetail?columnistId=${param.param}`);
        url.searchParams.forEach((v,k,p)=>{
            nextUrl.searchParams.set(k,v)
        });
        nativefun('handleUrl', {'param': nextUrl})
      }
      break
  }
}

/**
 * 任务链接跳转的时候，加上 page_source 参数
 * @param forwardLink
 * @param keyValue 待插入到url中的query键值对，结构类似：{key:value, key1:value1}   注意!!! 对于键值对中的value，不需要进行urlencode，因为在调用api设置key时，会默认encode一次
 * @returns {string|*}
 */
function refactorTaskForwardLink(forwardLink, keyValue) {
  if (forwardLink.indexOf("url=" != 1)) {
    const urlSplit = forwardLink.split("url=");
    const nativeUrl = urlSplit[0];
    const httpUrl = urlSplit[1];
    const newNativeUrl = decodeURI(encodeURI(nativeUrl).replace(/%E2%80%8B/g, ''))
    let url = new URL(newNativeUrl);
    // url.searchParams.set("page_source", pageSource);
    for (let key in keyValue) {
      url.searchParams.set(key, keyValue[key])
    }
    return decodeURIComponent(url) + "&url=" + httpUrl;
  }

  return forwardLink;
}

/**
 * 文章转发时，更新url中的pid（传播者）为当前用户的auth2或者AnonymousID（匿名ID）
 * @param shareUrl
 * @returns {string|*}
 */
function setUrlPid(shareUrl) {
  if (shareUrl.indexOf('/live/') !== -1 || shareUrl.indexOf('/doc/') !== -1) {
    const newShareUrl = decodeURI(encodeURI(shareUrl).replace(/%E2%80%8B/g, ''))
    let tempUrl = new URL(newShareUrl)
    tempUrl.searchParams.set('pid', head.auth2 ? head.auth2 : localStorage.getItem('AnonymousID'))
    return tempUrl.toString()
  } else {
    return shareUrl
  }
}

/**
 * 二次分享往URL中插入值
 * @param url 待操作的url
 * @param ambBinding 二次转发标识
 */
function modifyAmbUrl(ambUrl) {
  if (ambUrl.indexOf('ambBinding=')!= -1) {
    // 二次转发地址，不处理
    return ambUrl
  } else {
    if (ambUrl.indexOf('&shareCode=')!= -1) {
      // 已有shareCode，学习大使分享地址
      return ambUrl.replace('&shareCode=', '&ambBinding=1&shareCode=')
    } else {
      return ambUrl
    }
  }
}

/**
 * 往url中拼接query参数以及其对应的值，只会拼接到链接的最后，不管链接中是否带有# (链接中有同样的query的key,则value会覆盖)
 * @param url 待操作的url
 * @param keyValue 待插入到url中的query键值对 ，结构类似：{key:value, key1:value1}   注意!!! 对于键值对中的value，不需要进行urlencode，因为在调用api设置key时，会默认encode一下的
 */
function setUrlQueryEnd(url, keyValue) {
  if(url.indexOf('#/') != -1) {
    //url中有#，为了避免将query拼接到#前面，需要做特殊处理
    let tempPre = "https://test.liangyihui.net/" //假的链接
    let concatUrl = tempPre

    let urlSplit = url.split('#/')
    if (urlSplit.length > 1 && urlSplit[1]) {
      concatUrl = `${tempPre}${urlSplit[1]}`
    }

    let tempUrl = new URL(concatUrl) //concatUrl是为了绕过：链接中有#，然后设置query的话，query会拼接到#前面的情况
    for (let key in keyValue) {
      tempUrl.searchParams.set(key, keyValue[key])
    }

    return tempUrl.toString().replace(tempPre, `${urlSplit[0]}#/`) //将原始的url恢复回来
  } else {
    return setUrlQuery(url, keyValue)
  }
}

/**
 * 往url中拼接query参数以及其对应的值 (如果是良医汇带#的url,则query会拼接到#前面)
 * @param url 待操作的url
 * @param keyValue 待插入到url中的query键值对
 */
function setUrlQuery(url, keyValue) {
  let tempUrl = new URL(url)
  for (let key in keyValue) {
    tempUrl.searchParams.set(key, keyValue[key])
  }
  return tempUrl.toString()
}

/**
 *
 * 删除url中的指定query参数(不用管query是在#前面还是后面)
 * @param url 待操作的url
 * @param keySet 要删除的query参数的key的数组
 */
function deleteUrlQuerys4AnyUrl(url, keySet) {
  if (url.indexOf('#/') == -1) {
    return deleteUrlQuerys(url, keySet)
  } else {
    let preUrl = deleteUrlQuerys(url, keySet) //只能删除#前面的
    let endUrl = ''

    let urlSplit = preUrl.split('#/')

    if (urlSplit.length > 1 && urlSplit[1]) {
      let tempPre = "https://test.liangyihui.net/" //假的链接，是为了方便调用deleteUrlQuerys来移除#/后面的内容
      endUrl = deleteUrlQuerys(`${tempPre}${urlSplit[1]}`, keySet).replace(tempPre, '')
    }

    return `${urlSplit[0]}#/${endUrl}`
  }
}

/**
 *
 * 删除url中的指定query参数（不适用于删除#/后面的query参数，若是需要删除#/后面的query参数，请使用deleteUrlQuerys4AnyUrl）
 * @param url 待操作的url
 * @param keySet 要删除的query参数的key的数组
 */
function deleteUrlQuerys(url, keySet) {
  let tempUrl = new URL(url)
  for (let i = 0; i < keySet.length; i++) {
    tempUrl.searchParams.delete(keySet[i])
  }
  return tempUrl.toString()
}

/**
 * 获取设备ID（自定义的，非系统提供的）
 */
function getCid() {
  return new Promise( async (resolve) => {
    if (is_app()) {
      // App中使用APP传过来的设备ID
      if (head.cid) {
        resolve(head.cid)
      } else {
        // jsbridge初始化方法setupWebViewJavascriptBridge设置好后才设置的new Vue()，即在页面中调用本jsbridge方法是肯定没问题的
        nativefun('getHead1', {}, async (responseData) => {
          var obj = JSON.parse(responseData)
          if (obj && obj.cid) {
            resolve(obj.cid)
          } else {
            let anonymousid = await getSensorAnonymousID() || ''
            resolve(anonymousid)
          }
        })
      }
    } else {
      let anonymousid = await getSensorAnonymousID() || ''
      resolve(anonymousid)
    }
  })
}


/**
 * 获取神策匿名ID
 */
function getSensorAnonymousID() {
  return new Promise( (resolve) => {
    let anonymousid = localStorage.getItem('AnonymousID') || ''
    if (anonymousid) {
      resolve(anonymousid)
    } else {
      anonymousid = window.$sensors.quick('getAnonymousID')
      if (anonymousid) {
        resolve(anonymousid)
      } else {
        // 神策SDK初始化好了后，才会进行new Vue()，因此本处肯定能获取到神策的匿名ID的
        window.$sensors.quick('isReady',  () => {
          anonymousid = window.$sensors.quick('getAnonymousID')
          resolve(anonymousid)
        })
      }
    }
  })
}

/**
 * 设置新的PageLeave 自定义属性
 * @param props
 */
function setPageLeaveCustomProps(props) {
  Object.keys(props).forEach(key => {
    window.page_leave_custom_props[key] = props[key]
  })
}

function setPageLeaveCustomPropsKV(key, value) {
  window.page_leave_custom_props[key] = value
}

/**
 * 获取微信小程序的appId
*/
function getMiniAppId() {
  if (isInWechatMiniProgram) {
    const ua = navigator.userAgent;
    const match = ua.match(/miniProgram\/(wx[\w\d]+)/);
    // console.log('getMiniAppId ua:', ua);
    // console.log('getMiniAppId match:', match);
    return match ? match[1] : null;
  } else {
    return null;
  }
}
/**
 * 兼容小程序的登录
 * @param loginBury h5登录埋点需要的参数
 */
async function doLoginCompatMiniPro(loginBury) {
  if(isInWechatMiniProgram) {
    //微信小程序
    let pathPrefix = doctorMiniProgramPaths.commonWeb //公共页面（专栏等）
    if(location.href.indexOf('/doc/') != -1 || location.href.indexOf('/DocPreviewNew/') != -1 || location.href.indexOf('/DocPreview/') != -1) {
      //普通文章
      pathPrefix = doctorMiniProgramPaths.article
    } else if(location.href.indexOf('/live/') != -1 || location.href.indexOf('/LivePreviewNew/') != -1 || location.href.indexOf('/LivePreview/') != -1) {
      //公开课
      pathPrefix = doctorMiniProgramPaths.live
    }

    let url = `/${pathPrefix}${encodeURIComponent(location.href)}&dologin=1`
    // 判断 loginBury.pageSource 是否存在且不包含 'registerlogin_' 字符串，如果不包含则添加
    if (loginBury.pageSource && loginBury.pageSource.length > 0) {
      url += `&page_source=${encodeURIComponent(loginBury.pageSource)}`
    }

    wx.miniProgram.redirectTo({
      url: url //dologin为1标识小程序要跳转的页面需要弹出登录弹窗
    })
  } else {
    // 不包含 'registerlogin_' 时，进行添加（仅作用于业务已有的 pageSource，如工具页入口）
    if (loginBury && loginBury.pageSource && loginBury.pageSource.length > 0 && !loginBury.pageSource.includes('registerlogin_')) {
      loginBury.pageSource = 'registerlogin_' + loginBury.pageSource
    }
    //h5未登录引导 A/B 实验：着陆页（hash 带 experiment_group）触发登录时，注入 channel 与 pageSource 归因实验分组
    //pageSource（experiment_group_A/B）不追加 registerlogin_ 前缀，保持精确值供数据侧识别
    loginBury = mergeGuestGuideChannel(loginBury)
    const auth = await forceGetAuth(loginBury);
    head.auth = auth;

    // 登录成功后同步获取用户plan
    if (auth && typeof window.getUserInfoCompletePlan === 'function') {
      try {
        await window.getUserInfoCompletePlan();
        console.log('登录后已同步获取用户plan');
      } catch (error) {
        console.error('登录后获取用户plan失败:', error);
      }
    }
  }
}

/**
 * h5未登录引导 A/B 实验：当前 URL（hash 路由）带有 experiment_group 参数时，
 * 说明是经引导按钮跳转的着陆页，登录/身份验证/完善信息跳转归因实验分组：
 * - loginBury.pageSource 注入 experiment_group_A / experiment_group_B（保持精确值，不追加 registerlogin_ 前缀）
 * 作用域由 URL 天然限定：离开着陆页（hash 变化）即不再携带
 */
function mergeGuestGuideChannel(loginBury) {
  loginBury = loginBury || {}
  try {
    //query 在 hash 内（/#/doc/169720?experiment_group=A），getSearchParams 解析不到，需从 hash 取
    let match = location.hash.match(/[?&]experiment_group=([^&#]+)/)
    if (match && match[1]) {
      let guideChannel = 'experiment_group_' + decodeURIComponent(match[1])
      // loginBury.channel = loginBury.channel ? loginBury.channel + '|' + guideChannel : guideChannel
      //pageSource 仅在调用方未指定时注入，避免覆盖业务已有来源（如工具页的医学工具-意见反馈等）
      if (!loginBury.pageSource) {
        loginBury.pageSource = guideChannel
      }
    }
  } catch (e) {}
  return loginBury
}

async function doLogin(param) {
  let auth = ''
  if (param) {
    auth = await forceGetAuth(param)
  } else {
    auth = await forceGetAuth()
  }

  head.auth = auth

  if (window.ISPC || (window.ISMOBILE && !window.ISAPP && !window.ISWX)) {
    window.location.reload();
  }
}

/**
 * 是否是iOS环境
 */
function isIOS() {
  return browser.versions.iPhone || browser.versions.iPad || browser.versions.ios
}

/**
 * 将 base64 数据转换为 File 对象
 * @param {string} base64Data - base64 数据字符串
 * @param {string} fileName - 文件名
 * @returns {File}
 */
function base64DataToFile(base64Data, fileName) {
  var arr = base64Data.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}


/**
 * 将图片通过七牛转换成想要的尺寸
 * PS: 遇到超大图，图片会转换失败，变成白图
 */
function transPicToDestSize(url, destWidth, destHeight) {
  if (!destWidth || !destHeight) {
    return url
  }
  const ratio = window.devicePixelRatio ? window.devicePixelRatio : 3;
  const targetWidth = (destWidth * ratio).toFixed(0)
  const targetHeight = (destHeight * ratio).toFixed(0)
  return url ? `${url}?imageView2/1/w/${targetWidth}/h/${targetHeight}` : '//bosdev.liangyihui.net/big_logo.png'
}

/**
 * 将接口api/ad/getAds获取到的广告中的hylink字段转换成对应的goUrl，因为hylink是native的链接格式，需要转换成h5的链接格式
 * 本方法是直接从DoctorToolsIndex中拷贝的
*/
function modifyAdLinkData(item) {
  if (!item.hylink || item.hylink == '') {
    return null
  }
  // native的链接
  // 例lyh://native.liangyihui.net/NewsDetail?docId=xxxxxx
  var subject = ''
  if (item.hylink.indexOf('net/') <= -1) {
    return
  }
  var subject = item.hylink.split('net/')[1].split('?')[0]
  if (item.hylink.indexOf('?') > -1) {
    var id = item.hylink.split('net/')[1].split('?')[1].split('=')[1]
  }

  // NewsDetail  Live  CommentDetail Series
  // 专栏 专题 公开课 普通文章
  switch (subject) {
    case 'NewsDetail':
      item.goUrl = '#/doc/' + (id ? id : '')
      item.type = 'doc'
      // item.id = id
      item.from = '文章'
      break
    case 'live':
      item.goUrl = '#/live/' + (id ? id : '')
      item.type = 'live'
      // item.id = id
      item.from = '公开课'
      break
    case 'Series':
      item.goUrl = '#/subject/' + (id ? id : '')
      item.type = 'subject'
      // item.id = id
      item.from = '专题'
      break
    case 'ColumnDetail':
      item.goUrl = '#/column/' + (id ? id : '')
      item.type = 'column'
      // item.id = id
      item.from = '专栏'
      break
    case 'NewWeb':
      item.goUrl = item.hylink.split('url=')[1]
      item.type = 'link'
      // item.id = id
      item.from = '外链'
      break
    case 'web':
      item.goUrl = item.hylink.split('url=')[1]
      item.type = 'link'
      // item.id = id
      item.from = '外链'
      break
    default:
      item.from = '其他'
      item.goUrl = 'javascript:void(0)'
  }
  return item
}

/**
 * 是否微信小程序环境
 */
const isInWechatMiniProgram = (navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram'

/**
 * 判断当前环境是否应使用全屏高度（无需减去顶部导航栏 50px）
 * PC / App / MedSeekApp / iframe / 小程序 环境下返回 true
 */
function isFullViewportHeight() {
  return !!(window.ISPC || is_app() || window.ISMEDSEEKAPP || self != top || isInWechatMiniProgram)
}

/**
 * 获取页面高度样式字符串
 * @param {string} fullStyle - 全屏时的样式，默认 'height: 100vh;'
 * @param {string} reducedStyle - 非全屏时的样式，默认 'height: calc(100vh - 50px);'
 */
function getPageHeightStyle(fullStyle, reducedStyle) {
  return isFullViewportHeight()
    ? (fullStyle || 'height: 100vh;')
    : (reducedStyle || 'height: calc(100vh - 50px);')
}

var a1 = 1;

//console.log('advjs loaded');
var mdapiurl = window.Global_apiserver + "api/pub/setburieddata";

function advload(domid, reqmd, showmd, clickmd, clickhandle) {

  var domsearch = '#' + domid;
  // console.log('advload');
  //console.log(domsearch);
  if ($(domsearch).length > 0) {

    // console.log('A');
    //alert(domsearch)
    var gourl = $(domsearch).attr('gourl');
    var adid = $(domsearch).attr('adid');

    reqmd(adid); //请求埋点
    postmd();

    $(domsearch).unbind("click");
    $(domsearch).click(function () {
      // console.log('domsearchclick')
      clickmd(adid); //点击埋点
      postmd();
      clickhandle(adid, gourl);
      //document.location.href = gourl; // 取广告页面
    });

    var adshow = 0;

    $(window).scroll(function () {
      if (!adshow) {
        //fix 如：广告文章C，配置在公开课A中，点击广告跳到C，文章C中没有广告，导致监听滚动事件报错
        if(!$(domsearch)||$(domsearch).length==0){
          return
        }
        var otop = $(domsearch).offset().top;
        //console.log('otop:' + otop);
        var scrtop = $(document).scrollTop();
        //console.log('scrtop:' + scrtop);
        var whei = $(window).height();
        //console.log('whei:' + whei);
        if (0 < otop - scrtop && otop - scrtop < whei) {
          adshow = 1;
          showmd(adid); //出现在窗口中 展示埋点
          postmd();
          //$.alert('出现了 出现了 最淫荡的人出现了');
        }
      }
    })
  }

}

function bmsadvload(category, dataType, url, id) { //bms埋点


  //   var bmsmdurl = 'http://192.168.1.54:8088/idp/idp/verify/uploadbmsdata';
  // //          var apiurl = '47.96.252.14:8088/idp/idp/verify/uploadbmsdata';
  //   var bmsmdData = {
  //     head,
  //     category:1,
  //     dataType:2,
  //     link:url,
  //     referenceId:id,
  //   };
  //   $.ajax({
  //     url: bmsmdurl,
  //     data: JSON.stringify(bmsmdData),
  //     type: "POST",
  //     dataType: 'json',
  //     contentType: "application/json",
  //     success: function(data, textStatus, jqXHR) {
  //
  //     }
  //   });

  var bmsmdurl = 'http://192.168.1.54:8088/idp/idp/verify/uploadbmsdata';
  //          var apiurl = '47.96.252.14:8088/idp/idp/verify/uploadbmsdata';
  var bmsmdData = {
    head: head,
    category: category,
    dataType: dataType,
    link: url,
    referenceId: id,
  };
  $.ajax({
    url: bmsmdurl,
    data: JSON.stringify(bmsmdData),
    type: "POST",
    dataType: 'json',
    contentType: "application/json",
    success: function (data, textStatus, jqXHR) {

    }
  });

}

function laiyuanmd(docId) {

  var timestamp = (new Date()).valueOf();

  var cid = localStorage.getItem('cid');
  if (!cid) {
    cid = (new GUID()).newGUID();
    localStorage.setItem('cid', cid);
  }

  var guid = sessionStorage.getItem('D_guid');
  if (!guid) {
    guid = (new GUID()).newGUID();
    sessionStorage.setItem('D_guid', guid);
  }

  var startkey = 'D_starttime_' + docId;
  var starttime = sessionStorage.getItem(startkey);
  if (!starttime) {
    starttime = timestamp;
    sessionStorage.setItem(startkey, starttime);
  }
  var endtime = timestamp + 1000;

  return;

  var apiurl = Global_apiserver + "api/pub/setburieddataweb";
  var reqdata = {
    buriedItems: [
      {
        actionType: 1,
        contentType: 0,
        currentTime: starttime,
        params: [
          docId
        ],
        targetObject: "wechat"
      },
      {
        actionType: 2,
        contentType: 0,
        currentTime: endtime,
        params: [
          docId
        ],
        targetObject: "wechat"
      }
    ],
    head: {
      auth: window.auth,
      auth2: window.auth2,
      cid: cid,
      cver: 3.2,
      extensions: [
        {
          name: "platform",
          value: "H5"
        }
      ]
    },
    //"path": "/api/pub/setburieddataweb",
    sessionId: guid
  };

  $.ajax({
    url: apiurl,
    data: JSON.stringify(reqdata),
    type: "POST",
    dataType: 'json',
    contentType: "application/json",
    success: function (data, textStatus, jqXHR) {

    }
  });

  console.log(reqdata);

}


function postmd() {
  //mdapiurl mdjson
  //alert(1);
  //$.alert(JSON.stringify(mdjson));
  $.ajax({
    url: mdapiurl,
    data: JSON.stringify(mdjson),
    type: "POST",
    dataType: 'json',
    contentType: "application/json",
    success: function (data, textStatus, jqXHR) {

    }
  });

}
/**
 *
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 *
 **/

var Base64 = {

  // private property
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  // public method for encoding
  encode: function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

    }

    return output;
  },

  // public method for decoding
  decode: function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {

      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

    }

    output = Base64._utf8_decode(output);

    return output;

  },

  // private method for UTF-8 encoding
  _utf8_encode: function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      }
      else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      }
      else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  },

  // private method for UTF-8 decoding
  _utf8_decode: function (utftext) {
    var string = "";
    var i = 0;
    var c = 0 , c1 = 0 , c2 = 0;

    while (i < utftext.length) {

      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      }
      else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      }
      else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }

    }

    return string;
  }

}



!function (n) { "use strict"; function t(n, t) { var r = (65535 & n) + (65535 & t); return (n >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r } function r(n, t) { return n << t | n >>> 32 - t } function e(n, e, o, u, c, f) { return t(r(t(t(e, n), t(u, f)), c), o) } function o(n, t, r, o, u, c, f) { return e(t & r | ~t & o, n, t, u, c, f) } function u(n, t, r, o, u, c, f) { return e(t & o | r & ~o, n, t, u, c, f) } function c(n, t, r, o, u, c, f) { return e(t ^ r ^ o, n, t, u, c, f) } function f(n, t, r, o, u, c, f) { return e(r ^ (t | ~o), n, t, u, c, f) } function i(n, r) { n[r >> 5] |= 128 << r % 32, n[14 + (r + 64 >>> 9 << 4)] = r; var e, i, a, d, h, l = 1732584193, g = -271733879, v = -1732584194, m = 271733878; for (e = 0; e < n.length; e += 16)i = l, a = g, d = v, h = m, g = f(g = f(g = f(g = f(g = c(g = c(g = c(g = c(g = u(g = u(g = u(g = u(g = o(g = o(g = o(g = o(g, v = o(v, m = o(m, l = o(l, g, v, m, n[e], 7, -680876936), g, v, n[e + 1], 12, -389564586), l, g, n[e + 2], 17, 606105819), m, l, n[e + 3], 22, -1044525330), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 4], 7, -176418897), g, v, n[e + 5], 12, 1200080426), l, g, n[e + 6], 17, -1473231341), m, l, n[e + 7], 22, -45705983), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 8], 7, 1770035416), g, v, n[e + 9], 12, -1958414417), l, g, n[e + 10], 17, -42063), m, l, n[e + 11], 22, -1990404162), v = o(v, m = o(m, l = o(l, g, v, m, n[e + 12], 7, 1804603682), g, v, n[e + 13], 12, -40341101), l, g, n[e + 14], 17, -1502002290), m, l, n[e + 15], 22, 1236535329), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 1], 5, -165796510), g, v, n[e + 6], 9, -1069501632), l, g, n[e + 11], 14, 643717713), m, l, n[e], 20, -373897302), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 5], 5, -701558691), g, v, n[e + 10], 9, 38016083), l, g, n[e + 15], 14, -660478335), m, l, n[e + 4], 20, -405537848), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 9], 5, 568446438), g, v, n[e + 14], 9, -1019803690), l, g, n[e + 3], 14, -187363961), m, l, n[e + 8], 20, 1163531501), v = u(v, m = u(m, l = u(l, g, v, m, n[e + 13], 5, -1444681467), g, v, n[e + 2], 9, -51403784), l, g, n[e + 7], 14, 1735328473), m, l, n[e + 12], 20, -1926607734), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 5], 4, -378558), g, v, n[e + 8], 11, -2022574463), l, g, n[e + 11], 16, 1839030562), m, l, n[e + 14], 23, -35309556), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 1], 4, -1530992060), g, v, n[e + 4], 11, 1272893353), l, g, n[e + 7], 16, -155497632), m, l, n[e + 10], 23, -1094730640), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 13], 4, 681279174), g, v, n[e], 11, -358537222), l, g, n[e + 3], 16, -722521979), m, l, n[e + 6], 23, 76029189), v = c(v, m = c(m, l = c(l, g, v, m, n[e + 9], 4, -640364487), g, v, n[e + 12], 11, -421815835), l, g, n[e + 15], 16, 530742520), m, l, n[e + 2], 23, -995338651), v = f(v, m = f(m, l = f(l, g, v, m, n[e], 6, -198630844), g, v, n[e + 7], 10, 1126891415), l, g, n[e + 14], 15, -1416354905), m, l, n[e + 5], 21, -57434055), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 12], 6, 1700485571), g, v, n[e + 3], 10, -1894986606), l, g, n[e + 10], 15, -1051523), m, l, n[e + 1], 21, -2054922799), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 8], 6, 1873313359), g, v, n[e + 15], 10, -30611744), l, g, n[e + 6], 15, -1560198380), m, l, n[e + 13], 21, 1309151649), v = f(v, m = f(m, l = f(l, g, v, m, n[e + 4], 6, -145523070), g, v, n[e + 11], 10, -1120210379), l, g, n[e + 2], 15, 718787259), m, l, n[e + 9], 21, -343485551), l = t(l, i), g = t(g, a), v = t(v, d), m = t(m, h); return [l, g, v, m] } function a(n) { var t, r = "", e = 32 * n.length; for (t = 0; t < e; t += 8)r += String.fromCharCode(n[t >> 5] >>> t % 32 & 255); return r } function d(n) { var t, r = []; for (r[(n.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1)r[t] = 0; var e = 8 * n.length; for (t = 0; t < e; t += 8)r[t >> 5] |= (255 & n.charCodeAt(t / 8)) << t % 32; return r } function h(n) { return a(i(d(n), 8 * n.length)) } function l(n, t) { var r, e, o = d(n), u = [], c = []; for (u[15] = c[15] = void 0, o.length > 16 && (o = i(o, 8 * n.length)), r = 0; r < 16; r += 1)u[r] = 909522486 ^ o[r], c[r] = 1549556828 ^ o[r]; return e = i(u.concat(d(t)), 512 + 8 * t.length), a(i(c.concat(e), 640)) } function g(n) { var t, r, e = ""; for (r = 0; r < n.length; r += 1)t = n.charCodeAt(r), e += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t); return e } function v(n) { return unescape(encodeURIComponent(n)) } function m(n) { return h(v(n)) } function p(n) { return g(m(n)) } function s(n, t) { return l(v(n), v(t)) } function C(n, t) { return g(s(n, t)) } function A(n, t, r) { return t ? r ? s(t, n) : C(t, n) : r ? m(n) : p(n) } "function" == typeof define && define.amd ? define(function () { return A }) : "object" == typeof module && module.exports ? module.exports = A : n.md5 = A; window.md5 = A }(this);

(function() {
  window.aliyunlog = aliyunlog;
  window.s = s;
  window.auth1 = auth1;
  window.auth2 = auth2;
  window.version = version;
  window.head = head;
  window.wsharep = wsharep;
  window.liveuser = liveuser;
  window.chatunreader = chatunreader;
  window.eruda = eruda;
  window.openapp = openapp;
  window.getJskUrl = getJskUrl;
  window.goapp = goapp;
  window.appLinkUrl = appLinkUrl;
  window.gettimestamp = gettimestamp;
  window.wxshare = wxshare;
  window.getcachejson = getcachejson;
  window.setcachejson = setcachejson;
  window.wxwebjsk = wxwebjsk;
  window.setWxJssdkConfig = setWxJssdkConfig;
  window.eventHub = eventHub;
  window.is_app = is_app;
  window.isminiprogram = isminiprogram;
  window.isdoctorweb = isdoctorweb;
  window.isWxMiniProgram = isWxMiniProgram;
  window.recordTnmResult = recordTnmResult;
  window.getRecordTnmData = getRecordTnmData;
  window.saveRecordTnmData = saveRecordTnmData;
  window.is_hzzm = is_hzzm;
  window.searchjson = searchjson;
  window.JsonSort = JsonSort;
  window.global_register = global_register;
  window.timeStamp2String = timeStamp2String;
  window.secondsToHms_Integer = secondsToHms_Integer;
  window.getHospitalCategoryLevel = getHospitalCategoryLevel;
  window.compareVer = compareVer;
  window.changeoldvedio = changeoldvedio;
  window.removeHTMLTag = removeHTMLTag;
  window.gourl = gourl;
  window.gotoLoginHint = gotoLoginHint;
  window.gotoCertifyHint = gotoCertifyHint;
  window.gotoFocusColumn = gotoFocusColumn;
  window.checkStatus = checkStatus;
  window.goDoc = goDoc;
  window.goSubject = goSubject;
  window.goColunm = goColunm;
  window.IsPC = IsPC;
  window.webrouter = webrouter;
  window.is_weixin = is_weixin;
  // window.pb1 = pb1;
  // window.picitems = picitems;
  // window.pbisopen = pbisopen;
  window.setpb = setpb;
  window.GUID = GUID;
  window.isExitsFunction = isExitsFunction;
  window.bigpic = bigpic;
  window.mdjson = mdjson;
  window.guid = guid;
  window.Accordion = Accordion;
  window.$prevn = $prevn;
  window.$prevt = $prevt;
  window.thiskey = thiskey;
  window.prekey = prekey;
  window.docAccordion = docAccordion;
  window.getMonthDays = getMonthDays;
  window.lastmonthStartTime = lastmonthStartTime;
  window.lastmonthEndTime = lastmonthEndTime;
  window.setaliyunmaidian = setaliyunmaidian;
  window.judgeNumIsTel = judgeNumIsTel;
  window.setPageSource = setPageSource;
  window.getPageSource = getPageSource;
  window.setPageContent = setPageContent;
  window.getPageContent = getPageContent;
  window.registerPageContent = registerPageContent;
  window.bpFollow = bpFollow;
  window.getContentChannel = getContentChannel;
  window.modDocTypeName = modDocTypeName;
  window.getPid = getPid;
  window.getMCode = getMCode;
  window.getSearchParams = getSearchParams;
  window.setUrlPid = setUrlPid;
  window.modifyAmbUrl = modifyAmbUrl;
  window.setPageLeaveCustomProps = setPageLeaveCustomProps;
  window.setPageLeaveCustomPropsKV = setPageLeaveCustomPropsKV;
  window.a1 = a1;
  window.mdapiurl = mdapiurl;
  window.advload = advload;
  window.bmsadvload = bmsadvload;
  window.laiyuanmd = laiyuanmd;
  window.postmd = postmd;
  window.Base64 = Base64;
  window.refactorUrl = refactorUrl;
  window.refactorTaskForwardLink = refactorTaskForwardLink;
  window.isLiveClass = isLiveClass;
  window.setUrlQueryEnd = setUrlQueryEnd;
  window.setUrlQuery = setUrlQuery;
  window.getHashUrlEndQuery = getHashUrlEndQuery;
  window.deleteUrlQuerys4AnyUrl = deleteUrlQuerys4AnyUrl;
  window.deleteUrlQuerys = deleteUrlQuerys;
  window.getCid = getCid;
  window.getSensorAnonymousID = getSensorAnonymousID;
  window.transPicToDestSize = transPicToDestSize;
  window.doctorMiniProgramId = doctorMiniProgramId;
  window.doctorMiniProgramPaths = doctorMiniProgramPaths;
  window.generateShowShareParam = generateShowShareParam;
  window.transShareMiniProgramPic = transShareMiniProgramPic;
  window.isInWechatMiniProgram = isInWechatMiniProgram;
  window.isFullViewportHeight = isFullViewportHeight;
  window.getPageHeightStyle = getPageHeightStyle;
  window.getMiniAppId = getMiniAppId;
  window.doLoginCompatMiniPro = doLoginCompatMiniPro;
  window.doLogin = doLogin;
  window.isIOS = isIOS;
  window.modifyAdLinkData = modifyAdLinkData;
  window.base64DataToFile = base64DataToFile;
})();


// export default
// module.exports
var compressions = {
  aliyunlog,
  s,
  auth1,
  auth2,
  version,
  head,
  wsharep,
  liveuser,
  chatunreader,
  eruda,
  openapp,
  getJskUrl,
  goapp,
  appLinkUrl,
  gettimestamp,
  wxshare,
  getcachejson,
  setcachejson,
  wxwebjsk,
  setWxJssdkConfig,
  eventHub,
  is_app,
  isminiprogram,
  isdoctorweb,
  isWxMiniProgram,
  is_hzzm,
  searchjson,
  JsonSort,
  global_register,
  timeStamp2String,
  secondsToHms_Integer,
  getHospitalCategoryLevel,
  compareVer,
  changeoldvedio,
  removeHTMLTag,
  gourl,
  gotoLoginHint,
  gotoCertifyHint,
  gotoFocusColumn,
  checkStatus,
  goDoc,
  goSubject,
  goColunm,
  IsPC,
  webrouter,
  is_weixin,
  // pb1,
  // picitems,
  // pbisopen,
  setpb,
  GUID,
  isExitsFunction,
  bigpic,
  mdjson,
  guid,
  Accordion,
  $prevn,
  $prevt,
  thiskey,
  prekey,
  docAccordion,
  getMonthDays,
  lastmonthStartTime,
  lastmonthEndTime,
  setaliyunmaidian,
  judgeNumIsTel,
  setPageSource,
  getPageSource,
  setPageContent,
  getPageContent,
  registerPageContent,
  bpFollow,
  modDocTypeName,
  getContentChannel,
  getPid,
  getSearchParams,
  setUrlPid,
  modifyAmbUrl,
  setPageLeaveCustomProps,
  setPageLeaveCustomPropsKV,
  a1,
  mdapiurl,
  advload,
  bmsadvload,
  laiyuanmd,
  postmd,
  Base64,
  isLiveClass,
  setUrlQueryEnd,
  setUrlQuery,
  getHashUrlEndQuery,
  deleteUrlQuerys4AnyUrl,
  deleteUrlQuerys,
  getCid,
  getSensorAnonymousID,
  transPicToDestSize,
  doctorMiniProgramId,
  doctorMiniProgramPaths,
  getMiniAppId,
  doLoginCompatMiniPro,
  doLogin,
  isIOS,
  isFullViewportHeight,
  getPageHeightStyle,
  recordTnmResult,
  getRecordTnmData,
  saveRecordTnmData,
  modifyAdLinkData,
  base64DataToFile
}

// if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
//   module.exports = compressions;
// } else {
//   if (typeof define === 'function' && define.amd) {
//     define([], function() {
//       return compressions;
//     });
//   } else {
//     window.compressions = compressions;
//   }
// }
